const model = {
    "binarized": {
        "fp_font_preferences_default": [
            216.4506874999998,
            218.11663124999978,
            221.01011249999976,
            226.35866874999977,
            240.0369437499997
        ],
        "fp_font_preferences_sans": [
            195.8026875,
            200.518828125,
            212.945484375
        ],
        "fp_font_preferences_serif": [
            216.42127499999933,
            218.1108999999993,
            220.98326249999928,
            226.3900624999992,
            236.35884999999908
        ],
        "fp_font_preferences_system": [
            195.77295312499987,
            200.56120312499988,
            212.98072656249985
        ]
    },
    "equivalences": {
        "m_ac_hash": {
            "773650201040455": 175265213396771,
            "1160365973565005": 175265213396771,
            "1334051750864116": 1283506997072929,
            "1360095139423648": 568826444455191,
            "1479012367229551": 276815163012554,
            "1509642818930455": 28142358179959,
            "1528843162301021": 175265213396771,
            "1568309522498659": 175265213396771,
            "1633587301550488": 175265213396771,
            "1739657782064381": 175265213396771,
            "1787959153974993": 175265213396771,
            "1917794919801724": 175265213396771,
            "1975378173352497": 175265213396771,
            "2075856304974824": 1624409815516826,
            "2484185456100743": 175265213396771,
            "2671744493005248": 480731569750217,
            "2888834122454660": 446689074485913,
            "3205591418503039": 568826444455191,
            "3205741608824826": 175265213396771,
            "3217336799482969": 175265213396771,
            "3302929383242887": 2373250326736107,
            "3607129715820844": 28142358179959,
            "3708916655713932": 559259399154610,
            "3837692229611219": 175265213396771,
            "3844976480751442": 175265213396771,
            "3996887911677965": 568826444455191,
            "3997823267535577": 28142358179959,
            "4076967678028879": 175265213396771,
            "4178083976432717": 2464649300845354,
            "4325218025259923": 175265213396771,
            "4344041156584121": 222101954140526,
            "4355901628384826": 3203014098226425,
            "4401876646011186": 478284348450113,
            "4416014244946543": 3451135270253268,
            "4445695488261636": 175265213396771,
            "4456217864637304": 28142358179959,
            "4461028096102683": 371384069506930,
            "4469928728049255": 175265213396771
        },
        "m_nav_array_length": {
            "28": 27,
            "29": 27,
            "30": 24,
            "31": 25,
            "32": 25,
            "33": 25,
            "34": 25,
            "35": 27,
            "36": 27,
            "37": 27,
            "39": 25,
            "40": 25,
            "41": 27,
            "42": 27,
            "43": 25,
            "44": 27,
            "51": 50,
            "52": 50,
            "54": 53,
            "55": 53,
            "56": 53,
            "57": 53,
            "58": 53,
            "59": 53,
            "61": 25,
            "62": 27,
            "63": 27,
            "64": 27,
            "65": 27,
            "66": 27,
            "67": 27,
            "68": 27,
            "70": 25,
            "71": 27,
            "72": 27,
            "73": 27,
            "74": 27,
            "75": 27,
            "76": 27,
            "77": 27
        },
        "m_nav_hardware_concurrency": {
            "2": -1,
            "3": -1,
            "4": -1,
            "5": -1,
            "6": -1,
            "7": -1,
            "8": -1,
            "10": -1,
            "12": -1,
            "124": -1
        },
        "m_nav_device_memory": {
            "1.0": 0.5,
            "2.0": 0.5,
            "4.0": -1,
            "8.0": -1
        },
        "m_default_font_size": {
            "8": 6,
            "11": 6,
            "12": 9,
            "13": 6,
            "14": 10,
            "15": 6,
            "16": 6,
            "17": 6,
            "18": 10,
            "19": 6,
            "20": 10,
            "21": 10,
            "22": 7,
            "23": 10,
            "24": 6,
            "25": 6,
            "27": 6,
            "28": 6,
            "32": 10,
            "34": 6
        },
        "m_connection_type_hash": {
            "1833549020729239": 1659437292088960,
            "3411725773065293": 1659437292088960,
            "3540936965973202": 655635859615559
        },
        "m_keyboard_backquote_hash": {
            "97": 92,
            "100": 92,
            "132": 12,
            "196": 12,
            "210": 92,
            "336": 3,
            "344": 92,
            "385": 92,
            "421": 221,
            "493": 3
        },
        "m_keyboard_backslash_hash": {
            "143": 77,
            "182": 100,
            "210": 77,
            "221": 100,
            "273": 77,
            "343": 77,
            "372": 100,
            "385": 90,
            "436": 77
        },
        "m_keyboard_bracketleft_hash": {
            "113": 100,
            "196": 100,
            "220": 100,
            "272": 12,
            "317": 12,
            "336": 100,
            "344": 100,
            "509": 100
        },
        "m_keyboard_bracketright_hash": {
            "103": 100,
            "137": 100,
            "264": 102,
            "273": 100,
            "277": 100,
            "372": 100,
            "436": 100
        },
        "m_keyboard_comma_hash": {
            "381": 100,
            "411": 100
        },
        "m_keyboard_digit0_hash": {
            "100": 90,
            "218": 90
        },
        "m_keyboard_digit1_hash": {
            "155": 100,
            "259": 100
        },
        "m_keyboard_digit2_hash": {
            "78": 44,
            "100": 44
        },
        "m_keyboard_digit3_hash": {
            "150": 100,
            "243": 100
        },
        "m_keyboard_digit4_hash": {
            "100": 44,
            "203": 44
        },
        "m_keyboard_digit5_hash": {
            "213": 100,
            "390": 100
        },
        "m_keyboard_digit6_hash": {
            "220": 92,
            "495": 100
        },
        "m_keyboard_digit7_hash": {
            "113": 100,
            "323": 100
        },
        "m_keyboard_digit8_hash": {
            "100": 81,
            "365": 81,
            "437": 81
        },
        "m_keyboard_digit9_hash": {
            "294": 100,
            "436": 100
        },
        "m_keyboard_equal_hash": {
            "139": 100,
            "196": 100,
            "386": 100,
            "492": 59,
            "495": 100
        },
        "m_keyboard_intlbackslash_hash": {
            "143": 101,
            "210": 12,
            "273": 12,
            "385": 43,
            "493": 92
        },
        "m_keyboard_keya_hash": {
            "357": 100,
            "425": 100
        },
        "m_keyboard_keyb_hash": {
            "431": 100
        },
        "m_keyboard_keyc_hash": {
            "100": 85
        },
        "m_keyboard_keyd_hash": {
            "101": 100
        },
        "m_keyboard_keye_hash": {
            "267": 100
        },
        "m_keyboard_keyf_hash": {
            "387": 100
        },
        "m_keyboard_keyg_hash": {
            "301": 100
        },
        "m_keyboard_keyh_hash": {
            "100": 0
        },
        "m_keyboard_keyi_hash": {
            "458": 100
        },
        "m_keyboard_keyj_hash": {
            "158": 100
        },
        "m_keyboard_keyk_hash": {
            "100": 98
        },
        "m_keyboard_keyl_hash": {
            "289": 100
        },
        "m_keyboard_keym_hash": {
            "100": 48,
            "381": 48
        },
        "m_keyboard_keyn_hash": {
            "213": 100
        },
        "m_keyboard_keyo_hash": {
            "342": 100
        },
        "m_keyboard_keyp_hash": {
            "503": 100
        },
        "m_keyboard_keyq_hash": {
            "357": 100,
            "425": 100
        },
        "m_keyboard_keyr_hash": {
            "491": 100
        },
        "m_keyboard_keys_hash": {
            "100": 59
        },
        "m_keyboard_keyt_hash": {
            "436": 100
        },
        "m_keyboard_keyu_hash": {
            "100": 49
        },
        "m_keyboard_keyv_hash": {
            "100": 26
        },
        "m_keyboard_keyw_hash": {
            "100": 85,
            "147": 85
        },
        "m_keyboard_keyx_hash": {
            "392": 100
        },
        "m_keyboard_keyy_hash": {
            "100": 85,
            "246": 85
        },
        "m_keyboard_keyz_hash": {
            "100": 85,
            "147": 85,
            "246": 85
        },
        "m_keyboard_minus_hash": {
            "100": 38,
            "203": 38,
            "495": 73
        },
        "m_keyboard_period_hash": {
            "248": 100,
            "476": 100
        },
        "m_keyboard_quote_hash": {
            "90": 24,
            "100": 24,
            "143": 24,
            "196": 24,
            "203": 24,
            "224": 24,
            "336": 113,
            "392": 24
        },
        "m_keyboard_semicolon_hash": {
            "78": 48,
            "100": 48,
            "178": 48,
            "283": 48,
            "411": 48,
            "417": 48,
            "425": 48,
            "436": 48,
            "507": 48
        },
        "m_keyboard_slash_hash": {
            "421": 78,
            "437": 100,
            "495": 100
        },
        "m_wgl_unmasked_vendor_hash": {
            "164": 41,
            "612": 41,
            "869": 41,
            "1095": 110,
            "1160": 760,
            "1380": 110,
            "1514": 444,
            "1642": 41,
            "1652": 41,
            "1653": 41,
            "1709": 353,
            "1782": 41,
            "1870": 41
        },
        "m_wgl_aliased_line_wr_hash": {
            "274078329002996": 194786807593122,
            "689946572233623": 326278711910095,
            "710046666943031": 194786807593122,
            "795501442113074": 194786807593122,
            "913323004133988": 194786807593122,
            "1187792986988117": 326278711910095,
            "1708495608634086": 194786807593122,
            "1730589107453000": 326278711910095,
            "1804567158914644": 326278711910095,
            "2534359169941442": 194786807593122,
            "3124492569186527": 326278711910095,
            "3293576094984153": 2103298507253489,
            "3450710150210807": 1216213716756943,
            "3974172730172995": 194786807593122,
            "4056900969481237": 326278711910095,
            "4311875936271776": 194786807593122,
            "4415876432030733": 326278711910095
        },
        "m_wgl_aliased_point_sr_hash": {
            "726387134586835": 280780448062495,
            "913323004133988": 366306388573970,
            "979884661436007": 280780448062495,
            "1064380443689529": 280780448062495,
            "1395517451842818": 366306388573970,
            "1865763181015433": 162032504007992,
            "2137033711036762": 162032504007992,
            "2229272062185978": 280780448062495,
            "2487652226122814": 280780448062495,
            "2513573211170251": 1216213716756943,
            "2534359169941442": 366306388573970,
            "3066000126552920": 182044956516963,
            "3176581075723809": 98229283625217,
            "3450710150210807": 98229283625217,
            "3499575350672999": 280780448062495,
            "4106251312306027": 98229283625217,
            "4246648866327622": 280780448062495,
            "4474962859873003": 477587215467759,
            "4479235665496621": 366306388573970
        },
        "m_wgl_alpha_bits": {
            "0": -1,
            "8": -1
        },
        "m_wgl_blue_bits": {
            "0": -1,
            "8": -1
        },
        "m_wgl_depth_bits": {
            "0": -1,
            "24": -1
        },
        "m_wgl_green_bits": {
            "0": -1,
            "8": -1
        },
        "m_wgl_max_anisotropy": {
            "2": -1,
            "16": -1
        },
        "m_wgl_max_combined_texture_iu": {
            "20": -1,
            "32": -1,
            "48": -1,
            "64": -1,
            "96": -1,
            "128": -1,
            "192": -1,
            "384": -1,
            "768": -1
        },
        "m_wgl_max_cubemap_texture_size": {
            "4096": -1,
            "8192": -1,
            "16384": -1
        },
        "m_wgl_max_fragment_u_vectors": {
            "221": -1,
            "224": -1,
            "256": -1,
            "1024": -1,
            "4096": -1
        },
        "m_wgl_max_render_buffer_size": {
            "4096": -1,
            "8192": -1,
            "16383": -1,
            "16384": -1
        },
        "m_wgl_max_texture_image_u": {
            "16": -1,
            "32": -1,
            "64": -1,
            "128": -1
        },
        "m_wgl_max_texture_size": {
            "4096": -1,
            "8192": -1,
            "16384": -1,
            "32768": -1
        },
        "m_wgl_max_variying_vec": {
            "9": -1,
            "15": -1,
            "16": -1,
            "30": -1,
            "31": -1,
            "32": -1
        },
        "m_wgl_max_vertex_attrs": {
            "16": -1,
            "32": -1
        },
        "m_wgl_max_vertex_texture": {
            "4": -1,
            "16": -1,
            "32": -1,
            "64": -1,
            "128": -1
        },
        "m_wgl_max_vertex_uniform": {
            "253": -1,
            "256": -1,
            "1024": -1,
            "4096": -1
        },
        "m_wgl_max_viewport_dims_hash": {
            "45": 12,
            "51": 14,
            "62": 12,
            "65": 12,
            "66": 42,
            "72": 42,
            "75": 42,
            "89": 14,
            "94": 14,
            "98": 1,
            "100": 42,
            "104": 14,
            "118": 14,
            "122": 61
        },
        "m_wgl_red_bits": {
            "0": -1,
            "8": -1,
            "16": -1
        },
        "m_wgl_renderer_hash": {
            "453": 144,
            "988": 48
        },
        "m_wgl_shading_lang_version_hash": {
            "100": 4,
            "128": 9
        },
        "m_wgl_stencil_bits": {
            "0": -1
        },
        "m_wgl_version_hash": {
            "2028": 624,
            "2988": 133
        },
        "m_bb_lefts_n": {
            "2": 1,
            "7": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        "m_bb_rights_n": {
            "2": 1,
            "7": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        "m_bb_tops_n": {
            "2": 1,
            "7": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        "m_bb_tops_diff": {
            "84.8828125": 0,
            "100.0": 0,
            "101.0": 0,
            "166.00000762939453": 166,
            "332.00001215934753": 332,
            "414.99462890625": 414.994140625,
            "415.0": 0,
            "415.00001525878906": 414.9998779296875,
            "415.00001895427704": 414.9999694824219,
            "415.0000305175781": 0,
            "415.00003814697266": 414.99951171875,
            "415.00006103515625": 0,
            "415.0001220703125": 414.9998779296875,
            "415.000244140625": 0,
            "415.00048828125": 0,
            "498.0000057220459": 498
        },
        "m_bb_bottoms_n": {
            "2": 1,
            "7": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        "m_bb_bottoms_diff": {
            "84.8828125": 0,
            "100.0": 0,
            "101.0": 0,
            "166.0000228881836": 166,
            "332.00001525878906": 332.000004529953,
            "415.0": 0,
            "415.00001525878906": 0,
            "415.00001895427704": 0,
            "415.0000228881836": 0,
            "415.0000305175781": 0,
            "415.0000457763672": 0,
            "415.00006103515625": 0,
            "415.0001220703125": 0,
            "415.000244140625": 0,
            "498.000036239624": 498
        },
        "m_bb_heights_n": {
            "2": 1,
            "7": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        "m_bb_heights_diff": {
            "7.62939453125e-06": 0,
            "1.52587890625e-05": 0,
            "2.288818359375e-05": 0,
            "3.0517578125e-05": 0,
            "6.103515625e-05": 0,
            "0.0001220703125": 0,
            "0.000244140625": 0,
            "0.00048828125": 0
        },
        "m_default_letter_size_tuple_000": {
            "7": 5,
            "9": 6,
            "10": 6,
            "11": 6,
            "12": 8,
            "13": 5,
            "14": 0,
            "15": 0,
            "16": 5,
            "17": 8,
            "18": 6,
            "19": 5,
            "20": 8,
            "21": 6,
            "22": 6,
            "23": 5,
            "24": 6,
            "25": 0,
            "26": 8,
            "27": 8,
            "30": 28,
            "32": 0
        },
        "fp_fonts_bow_000": {
            "1": 0
        },
        "fp_font_preferences_default_binarized": {
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0
        },
        "fp_font_preferences_sans_binarized": {
            "1": 0,
            "2": 0,
            "3": 0
        },
        "fp_font_preferences_serif_binarized": {
            "3": 0,
            "5": 0
        },
        "fp_font_preferences_system_binarized": {
            "1": 0,
            "2": 0,
            "3": 0
        }
    },
    "dsHashFeatures": [
        "fp_color_gamut_hash",
        "fp_fonts_bow_000_equivalences",
        "m_wgl_supported_extensions_bow_012",
        "fp_fonts_bow_002",
        "m_date_full_year0",
        "m_wgl_supported_extensions_bow_020",
        "m_wgl_supported_extensions_bow_027",
        "fp_languages_bow_025",
        "m_nav_hardware_concurrency",
        "m_keyboard_comma_hash",
        "fp_languages_bow_002",
        "m_canvas_geometry_fisher_13",
        "fp_screen_resolution_tuple_000",
        "m_wgl_unmasked_renderer_hash",
        "m_local_stg_estimate_quota",
        "m_canvas_geometry_fisher_4",
        "fp_screen_frame_tuple_002",
        "m_audio_sawtooth",
        "m_nav_device_memory_equivalences",
        "fp_fonts_bow_006",
        "m_nav_prototype_bow_008",
        "fp_timezone_hash",
        "fp_languages_bow_013",
        "m_keyboard_bracketleft_hash_equivalences",
        "m_wgl_max_fragment_u_vectors",
        "fp_fonts_bow_004",
        "fp_font_preferences_default_binarized",
        "fp_fonts_bow_013",
        "fp_fonts_bow_005",
        "m_wgl_max_cubemap_texture_size",
        "m_nav_hardware_concurrency_equivalences",
        "m_wgl_max_variying_vec",
        "m_codecs_streaming_hash",
        "m_datetime_format_locale_hash",
        "m_wgl_v_shader_li_range_min"
    ],
    "csplitterFeatures": [
        "lat",
        "lng",
        "ip_hash",
        "m_wgl_data_hash",
        "fp_languages_hashbow",
        "m_ac_hash",
        "m_media_audio_in_hash",
        "m_media_video_in_hash",
        "m_nav_user_agent_hash",
        "m_default_letter_size_hash",
        "m_nav_array_hashbow",
        "m_connection_hash",
        "fp_platform_hash",
        "m_nav_prototype_hashbow",
        "m_connection_type_hash",
        "m_keyboard_hash",
        "m_keyboard_backquote_hash",
        "m_keyboard_backslash_hash",
        "m_keyboard_bracketleft_hash",
        "m_keyboard_bracketright_hash",
        "m_keyboard_comma_hash",
        "m_keyboard_digit0_hash",
        "m_keyboard_digit1_hash",
        "m_keyboard_digit2_hash",
        "m_keyboard_digit3_hash",
        "m_keyboard_digit4_hash",
        "m_keyboard_digit5_hash",
        "m_keyboard_digit6_hash",
        "m_keyboard_digit7_hash",
        "m_keyboard_digit8_hash",
        "m_keyboard_digit9_hash",
        "m_keyboard_equal_hash",
        "m_keyboard_intlbackslash_hash",
        "m_keyboard_keya_hash",
        "m_keyboard_keyb_hash",
        "m_keyboard_keyc_hash",
        "m_keyboard_keyd_hash",
        "m_keyboard_keye_hash",
        "m_keyboard_keyf_hash",
        "m_keyboard_keyg_hash",
        "m_keyboard_keyh_hash",
        "m_keyboard_keyi_hash",
        "m_keyboard_keyj_hash",
        "m_keyboard_keyk_hash",
        "m_keyboard_keyl_hash",
        "m_keyboard_keym_hash",
        "m_keyboard_keyn_hash",
        "m_keyboard_keyo_hash",
        "m_keyboard_keyp_hash",
        "m_keyboard_keyq_hash",
        "m_keyboard_keyr_hash",
        "m_keyboard_keys_hash",
        "m_keyboard_keyt_hash",
        "m_keyboard_keyu_hash",
        "m_keyboard_keyv_hash",
        "m_keyboard_keyw_hash",
        "m_keyboard_keyx_hash",
        "m_keyboard_keyy_hash",
        "m_keyboard_keyz_hash",
        "m_keyboard_minus_hash",
        "m_keyboard_period_hash",
        "m_keyboard_quote_hash",
        "m_keyboard_semicolon_hash",
        "m_keyboard_slash_hash",
        "m_keyboard_backquote_hash_equivalences",
        "m_keyboard_backslash_hash_equivalences",
        "m_keyboard_bracketleft_hash_equivalences",
        "m_keyboard_bracketright_hash_equivalences",
        "m_keyboard_comma_hash_equivalences",
        "m_keyboard_digit0_hash_equivalences",
        "m_keyboard_digit1_hash_equivalences",
        "m_keyboard_digit2_hash_equivalences",
        "m_keyboard_digit3_hash_equivalences",
        "m_keyboard_digit4_hash_equivalences",
        "m_keyboard_digit5_hash_equivalences",
        "m_keyboard_digit6_hash_equivalences",
        "m_keyboard_digit7_hash_equivalences",
        "m_keyboard_digit8_hash_equivalences",
        "m_keyboard_digit9_hash_equivalences",
        "m_keyboard_equal_hash_equivalences",
        "m_keyboard_intlbackslash_hash_equivalences",
        "m_keyboard_keya_hash_equivalences",
        "m_keyboard_keyb_hash_equivalences",
        "m_keyboard_keyc_hash_equivalences",
        "m_keyboard_keyd_hash_equivalences",
        "m_keyboard_keye_hash_equivalences",
        "m_keyboard_keyf_hash_equivalences",
        "m_keyboard_keyg_hash_equivalences",
        "m_keyboard_keyh_hash_equivalences",
        "m_keyboard_keyi_hash_equivalences",
        "m_keyboard_keyj_hash_equivalences",
        "m_keyboard_keyk_hash_equivalences",
        "m_keyboard_keyl_hash_equivalences",
        "m_keyboard_keym_hash_equivalences",
        "m_keyboard_keyn_hash_equivalences",
        "m_keyboard_keyo_hash_equivalences",
        "m_keyboard_keyp_hash_equivalences",
        "m_keyboard_keyq_hash_equivalences",
        "m_keyboard_keyr_hash_equivalences",
        "m_keyboard_keys_hash_equivalences",
        "m_keyboard_keyt_hash_equivalences",
        "m_keyboard_keyu_hash_equivalences",
        "m_keyboard_keyv_hash_equivalences",
        "m_keyboard_keyw_hash_equivalences",
        "m_keyboard_keyx_hash_equivalences",
        "m_keyboard_keyy_hash_equivalences",
        "m_keyboard_keyz_hash_equivalences",
        "m_keyboard_minus_hash_equivalences",
        "m_keyboard_period_hash_equivalences",
        "m_keyboard_quote_hash_equivalences",
        "m_keyboard_semicolon_hash_equivalences",
        "m_keyboard_slash_hash_equivalences",
        "m_bb_lefts_max",
        "m_bb_lefts_min",
        "m_bb_lefts_n",
        "m_bb_lefts_diff",
        "m_bb_rights_max",
        "m_bb_rights_min",
        "m_bb_rights_n",
        "m_bb_rights_diff",
        "m_bb_tops_max",
        "m_bb_tops_min",
        "m_bb_tops_n",
        "m_bb_tops_diff",
        "m_bb_bottoms_max",
        "m_bb_bottoms_min",
        "m_bb_bottoms_n",
        "m_bb_bottoms_diff",
        "m_bb_heights_max",
        "m_bb_heights_min",
        "m_bb_heights_n",
        "m_bb_heights_diff",
        "m_bb_lefts_n_equivalences",
        "m_bb_rights_n_equivalences",
        "m_bb_tops_n_equivalences",
        "m_bb_tops_diff_equivalences",
        "m_bb_bottoms_n_equivalences",
        "m_bb_bottoms_diff_equivalences",
        "m_bb_heights_n_equivalences",
        "m_bb_heights_diff_equivalences",
        "m_wgl_hash",
        "m_wgl_unmasked_renderer_hash",
        "m_wgl_unmasked_vendor_hash",
        "m_wgl_aliased_line_wr_hash",
        "m_wgl_aliased_point_sr_hash",
        "m_wgl_alpha_bits",
        "m_wgl_blue_bits",
        "m_wgl_depth_bits",
        "m_wgl_green_bits",
        "m_wgl_antialias_hash",
        "m_wgl_max_anisotropy",
        "m_wgl_max_combined_texture_iu",
        "m_wgl_max_cubemap_texture_size",
        "m_wgl_max_fragment_u_vectors",
        "m_wgl_max_render_buffer_size",
        "m_wgl_max_texture_image_u",
        "m_wgl_max_texture_size",
        "m_wgl_max_variying_vec",
        "m_wgl_max_vertex_attrs",
        "m_wgl_max_vertex_texture",
        "m_wgl_max_vertex_uniform",
        "m_wgl_max_viewport_dims_hash",
        "m_wgl_red_bits",
        "m_wgl_renderer_hash",
        "m_wgl_shading_lang_version_hash",
        "m_wgl_stencil_bits",
        "m_wgl_vendor_hash",
        "m_wgl_version_hash",
        "m_wgl_unmasked_vendor_hash_equivalences",
        "m_wgl_aliased_line_wr_hash_equivalences",
        "m_wgl_aliased_point_sr_hash_equivalences",
        "m_wgl_alpha_bits_equivalences",
        "m_wgl_blue_bits_equivalences",
        "m_wgl_depth_bits_equivalences",
        "m_wgl_green_bits_equivalences",
        "m_wgl_max_anisotropy_equivalences",
        "m_wgl_max_combined_texture_iu_equivalences",
        "m_wgl_max_cubemap_texture_size_equivalences",
        "m_wgl_max_fragment_u_vectors_equivalences",
        "m_wgl_max_render_buffer_size_equivalences",
        "m_wgl_max_texture_image_u_equivalences",
        "m_wgl_max_texture_size_equivalences",
        "m_wgl_max_variying_vec_equivalences",
        "m_wgl_max_vertex_attrs_equivalences",
        "m_wgl_max_vertex_texture_equivalences",
        "m_wgl_max_vertex_uniform_equivalences",
        "m_wgl_max_viewport_dims_hash_equivalences",
        "m_wgl_red_bits_equivalences",
        "m_wgl_renderer_hash_equivalences",
        "m_wgl_shading_lang_version_hash_equivalences",
        "m_wgl_stencil_bits_equivalences",
        "m_wgl_version_hash_equivalences",
        "fp_font_preferences_apple",
        "fp_font_preferences_default",
        "fp_font_preferences_min",
        "fp_font_preferences_mono",
        "fp_font_preferences_sans",
        "fp_font_preferences_serif",
        "fp_font_preferences_system",
        "fp_font_preferences_default_binarized_equivalences",
        "fp_font_preferences_sans_binarized_equivalences",
        "fp_font_preferences_serif_binarized_equivalences",
        "fp_font_preferences_system_binarized_equivalences",
        "m_canvas_geometry_hash",
        "m_canvas_text_hash",
        "m_canvas_text_gradient_hash",
        "m_canvas_curve_hash",
        "m_canvas_draw_all_hash",
        "m_canvas_emojis_hash",
        "m_default_font_size_equivalences",
        "m_canvas_draw_all_fisher_6",
        "m_win_inner_w",
        "m_ac_hash_equivalences",
        "m_local_stg_length",
        "m_canvas_draw_all_fisher_2",
        "m_canvas_draw_all_fisher_7",
        "fp_canvas_text_fisher_2",
        "m_local_stg_estimate_usage",
        "m_win_screen_x",
        "m_connection_downlink",
        "m_canvas_emojis_fisher_6",
        "m_canvas_draw_all_fisher_12",
        "m_local_stg_estimate_usage_details_idb",
        "m_win_outter_h",
        "m_canvas_emojis_fisher_5",
        "m_default_font_size",
        "m_nav_array_length_equivalences",
        "m_connection_type_hash_equivalences",
        "m_canvas_emojis_fisher_12",
        "m_canvas_draw_all_fisher_3",
        "m_win_inner_h",
        "m_canvas_draw_all_fisher_10",
        "m_battery_discharging_time",
        "m_connection_rtt",
        "m_connection_downlink_max",
        "m_battery_percentage",
        "m_nav_array_length",
        "m_battery_charging_time",
        "m_default_letter_size_tuple_000_equivalences",
        "fp_canvas_text_fisher_12",
        "fp_screen_frame_tuple_000",
        "fp_screen_frame_tuple_001",
        "fp_screen_frame_tuple_002",
        "fp_screen_frame_tuple_003",
        "m_default_letter_size_tuple_000",
        "m_default_letter_size_tuple_001",
        "m_nav_prototype_bow_000",
        "m_nav_prototype_bow_001",
        "m_nav_prototype_bow_002",
        "m_nav_prototype_bow_003",
        "m_nav_prototype_bow_004",
        "m_nav_prototype_bow_005",
        "m_nav_prototype_bow_006",
        "m_nav_prototype_bow_007",
        "m_nav_prototype_bow_008",
        "m_nav_prototype_bow_009",
        "m_nav_prototype_bow_010",
        "m_nav_prototype_bow_011",
        "m_nav_prototype_bow_012",
        "m_nav_prototype_bow_013",
        "m_nav_prototype_bow_014",
        "m_nav_prototype_bow_015"
    ],
    "fisher": {
        "fp_canvas_text": {
            "fp_canvas_text_fisher_12": {
                "x": [
                    124,
                    217,
                    100,
                    123,
                    229,
                    219,
                    233,
                    188,
                    215,
                    17,
                    102,
                    228,
                    213,
                    235,
                    72,
                    218,
                    14,
                    161,
                    192,
                    222,
                    210,
                    109,
                    221,
                    175,
                    16,
                    133,
                    228,
                    193,
                    174,
                    57,
                    215,
                    208,
                    233,
                    231,
                    158,
                    131,
                    215,
                    133,
                    54,
                    137,
                    34,
                    151,
                    128,
                    8,
                    25,
                    49,
                    84,
                    129,
                    230,
                    177,
                    104,
                    101,
                    217,
                    45,
                    226,
                    122,
                    225,
                    230,
                    224,
                    102,
                    230,
                    226,
                    223,
                    160,
                    134,
                    226,
                    232,
                    229,
                    111,
                    120,
                    210,
                    20,
                    156,
                    61,
                    177,
                    217,
                    127,
                    99,
                    233,
                    227,
                    128,
                    89,
                    209,
                    121,
                    171,
                    8,
                    57,
                    88,
                    81,
                    112,
                    193,
                    94,
                    86,
                    215,
                    81,
                    231,
                    143,
                    214,
                    157,
                    212,
                    208,
                    222,
                    114,
                    209,
                    215,
                    211,
                    129,
                    29,
                    108,
                    135,
                    95,
                    180,
                    193,
                    73,
                    200,
                    98,
                    130,
                    238,
                    223,
                    225,
                    221,
                    66,
                    138,
                    14,
                    53,
                    209,
                    216,
                    216,
                    149,
                    222,
                    216,
                    213,
                    100,
                    215,
                    223,
                    20,
                    218,
                    131,
                    30,
                    177,
                    217,
                    215,
                    31,
                    48,
                    228,
                    124,
                    66,
                    158,
                    69,
                    197,
                    56,
                    135,
                    141,
                    198,
                    38,
                    214,
                    201,
                    218,
                    236,
                    67,
                    127,
                    155,
                    189,
                    76,
                    99,
                    6,
                    218,
                    194,
                    89,
                    228,
                    213,
                    209,
                    130,
                    84,
                    219,
                    198,
                    123,
                    230,
                    215,
                    211,
                    132,
                    78,
                    30,
                    93,
                    137,
                    134,
                    144,
                    191,
                    85,
                    224
                ],
                "y": [
                    2,
                    48,
                    31,
                    43,
                    25,
                    35,
                    28,
                    43,
                    34,
                    33,
                    14,
                    29,
                    38,
                    34,
                    33,
                    39,
                    45,
                    32,
                    41,
                    40,
                    43,
                    12,
                    41,
                    47,
                    28,
                    13,
                    38,
                    43,
                    49,
                    34,
                    25,
                    36,
                    34,
                    40,
                    35,
                    7,
                    45,
                    44,
                    36,
                    6,
                    37,
                    35,
                    43,
                    28,
                    37,
                    32,
                    34,
                    40,
                    40,
                    41,
                    8,
                    32,
                    34,
                    14,
                    24,
                    12,
                    44,
                    41,
                    48,
                    36,
                    24,
                    26,
                    38,
                    38,
                    7,
                    45,
                    48,
                    34,
                    8,
                    42,
                    31,
                    32,
                    27,
                    10,
                    34,
                    44,
                    14,
                    34,
                    39,
                    26,
                    37,
                    12,
                    40,
                    39,
                    44,
                    38,
                    7,
                    35,
                    41,
                    39,
                    46,
                    8,
                    36,
                    35,
                    35,
                    32,
                    35,
                    46,
                    34,
                    28,
                    42,
                    48,
                    44,
                    37,
                    46,
                    33,
                    35,
                    40,
                    42,
                    32,
                    14,
                    35,
                    33,
                    29,
                    35,
                    10,
                    42,
                    29,
                    48,
                    42,
                    36,
                    30,
                    34,
                    42,
                    34,
                    42,
                    31,
                    36,
                    9,
                    43,
                    27,
                    32,
                    33,
                    44,
                    39,
                    31,
                    23,
                    37,
                    41,
                    42,
                    31,
                    28,
                    32,
                    8,
                    45,
                    11,
                    13,
                    33,
                    9,
                    34,
                    44,
                    41,
                    39,
                    40,
                    34,
                    47,
                    33,
                    35,
                    33,
                    28,
                    8,
                    42,
                    32,
                    32,
                    12,
                    6,
                    29,
                    37,
                    42,
                    31,
                    40,
                    38,
                    14,
                    9,
                    37,
                    32,
                    39,
                    30,
                    26,
                    42,
                    42,
                    13,
                    38,
                    9,
                    35,
                    39,
                    9,
                    38,
                    34,
                    27
                ],
                "channel": [
                    2,
                    2,
                    1,
                    1,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    1,
                    1,
                    0,
                    1,
                    2,
                    2,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    2,
                    2,
                    1,
                    2,
                    2,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    0,
                    2,
                    2,
                    1,
                    2,
                    1,
                    1,
                    2,
                    2,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    0,
                    1,
                    1,
                    2,
                    1,
                    2,
                    0,
                    1,
                    0,
                    2,
                    1,
                    1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    2,
                    1,
                    2,
                    1,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    0,
                    1,
                    1,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    0,
                    1,
                    2,
                    0,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    2,
                    1,
                    0,
                    1,
                    0,
                    1,
                    1,
                    2,
                    1,
                    1,
                    0
                ],
                "coefs": [
                    1.787109375,
                    0.0275421142578125,
                    -0.1824951171875,
                    -0.2120361328125,
                    0.054962158203125,
                    0.190185546875,
                    0.21630859375,
                    0.390380859375,
                    -0.29736328125,
                    -0.10894775390625,
                    0.638671875,
                    -0.70556640625,
                    0.77978515625,
                    0.0472412109375,
                    -0.32861328125,
                    -0.374755859375,
                    0.487548828125,
                    0.325439453125,
                    0.1695556640625,
                    -0.1983642578125,
                    0.005268096923828125,
                    0.572265625,
                    0.806640625,
                    -0.127685546875,
                    0.89111328125,
                    0.28076171875,
                    1.1201171875,
                    -0.1551513671875,
                    0.1400146484375,
                    -0.24072265625,
                    -0.0640869140625,
                    -0.2269287109375,
                    0.65673828125,
                    0.02911376953125,
                    0.342041015625,
                    0.65283203125,
                    0.390625,
                    0.1292724609375,
                    -0.56494140625,
                    1.416015625,
                    0.0229339599609375,
                    0.703125,
                    0.60546875,
                    0.2447509765625,
                    -0.1712646484375,
                    -0.01354217529296875,
                    -0.18017578125,
                    0.092529296875,
                    -0.3193359375,
                    0.509765625,
                    0.1529541015625,
                    -0.0870361328125,
                    -0.17529296875,
                    0.94921875,
                    0.447021484375,
                    0.013336181640625,
                    0.381591796875,
                    -0.20263671875,
                    1.0185546875,
                    -0.58251953125,
                    -0.1353759765625,
                    -0.52734375,
                    1.3310546875,
                    -0.220703125,
                    0.464599609375,
                    -0.33984375,
                    0.35205078125,
                    -0.01508331298828125,
                    0.60400390625,
                    0.385009765625,
                    0.316162109375,
                    -0.1478271484375,
                    0.69873046875,
                    -0.2330322265625,
                    0.1697998046875,
                    -0.09521484375,
                    0.58056640625,
                    -0.299072265625,
                    -0.0394287109375,
                    -0.35400390625,
                    -0.03875732421875,
                    0.92041015625,
                    0.0236053466796875,
                    -0.35693359375,
                    0.50830078125,
                    0.1331787109375,
                    0.53662109375,
                    0.26708984375,
                    -0.33203125,
                    0.80419921875,
                    -0.365478515625,
                    0.2392578125,
                    0.452880859375,
                    0.447998046875,
                    0.06195068359375,
                    0.740234375,
                    -0.0033416748046875,
                    0.380126953125,
                    0.0697021484375,
                    -0.2724609375,
                    0.43798828125,
                    0.032135009765625,
                    0.360595703125,
                    -0.05413818359375,
                    -0.0036945343017578125,
                    0.414794921875,
                    -0.313720703125,
                    0.3857421875,
                    0.2010498046875,
                    0.2274169921875,
                    1.2626953125,
                    0.480712890625,
                    0.2220458984375,
                    0.28857421875,
                    0.00357818603515625,
                    -0.17822265625,
                    -0.284423828125,
                    0.52001953125,
                    -0.0875244140625,
                    0.220947265625,
                    0.461181640625,
                    -0.27392578125,
                    0.1522216796875,
                    -0.1361083984375,
                    0.302978515625,
                    0.39208984375,
                    0.525390625,
                    -0.10198974609375,
                    0.56884765625,
                    0.421875,
                    -0.7236328125,
                    -0.111572265625,
                    -0.322265625,
                    0.039520263671875,
                    -0.0802001953125,
                    -0.31103515625,
                    0.265380859375,
                    0.5537109375,
                    -0.499267578125,
                    -0.2462158203125,
                    0.29150390625,
                    0.60205078125,
                    0.2166748046875,
                    0.199462890625,
                    0.20849609375,
                    0.1685791015625,
                    -0.1943359375,
                    0.10284423828125,
                    0.378662109375,
                    0.031463623046875,
                    0.38623046875,
                    0.17236328125,
                    -0.2939453125,
                    -0.2322998046875,
                    0.10302734375,
                    -0.1583251953125,
                    -0.1685791015625,
                    0.365966796875,
                    -0.051055908203125,
                    -0.0787353515625,
                    0.1578369140625,
                    0.321044921875,
                    0.0887451171875,
                    0.47705078125,
                    0.2666015625,
                    -0.2734375,
                    0.1287841796875,
                    0.1640625,
                    -0.186767578125,
                    0.3056640625,
                    0.483154296875,
                    0.1505126953125,
                    -0.092529296875,
                    -0.09161376953125,
                    0.2135009765625,
                    0.142822265625,
                    0.08087158203125,
                    -0.217041015625,
                    -0.20751953125,
                    0.1260986328125,
                    -0.1510009765625,
                    0.4296875,
                    0.337646484375,
                    0.1343994140625,
                    0.146240234375,
                    0.1444091796875,
                    0.1717529296875,
                    0.07379150390625,
                    -0.10284423828125,
                    -0.2420654296875
                ],
                "intercept": 61.125,
                "mean": 3855.921975035147
            },
            "fp_canvas_text_fisher_2": {
                "x": [
                    230,
                    107,
                    228,
                    229,
                    212,
                    100,
                    122,
                    214,
                    190,
                    231,
                    216,
                    215,
                    177,
                    84,
                    228,
                    163,
                    131,
                    54,
                    147,
                    201,
                    130,
                    220,
                    218,
                    109,
                    220,
                    131,
                    128,
                    13,
                    220,
                    223,
                    30,
                    146,
                    214,
                    234,
                    91,
                    33,
                    88,
                    86,
                    127,
                    231,
                    100,
                    121,
                    211,
                    105,
                    131,
                    222,
                    228,
                    71,
                    229,
                    232,
                    219,
                    210,
                    164,
                    67,
                    126,
                    217,
                    227,
                    45,
                    162,
                    213,
                    111,
                    231,
                    193,
                    75,
                    197,
                    42,
                    171,
                    124,
                    231,
                    71,
                    132,
                    210,
                    216,
                    106,
                    87,
                    223,
                    39
                ],
                "y": [
                    27,
                    5,
                    31,
                    32,
                    28,
                    14,
                    44,
                    29,
                    35,
                    40,
                    34,
                    47,
                    34,
                    42,
                    45,
                    42,
                    45,
                    41,
                    41,
                    33,
                    34,
                    40,
                    39,
                    5,
                    34,
                    13,
                    7,
                    42,
                    48,
                    31,
                    9,
                    34,
                    46,
                    35,
                    44,
                    39,
                    43,
                    40,
                    13,
                    38,
                    33,
                    36,
                    39,
                    9,
                    7,
                    24,
                    42,
                    27,
                    25,
                    41,
                    28,
                    32,
                    44,
                    28,
                    34,
                    33,
                    40,
                    34,
                    34,
                    26,
                    9,
                    39,
                    35,
                    30,
                    34,
                    32,
                    42,
                    14,
                    30,
                    47,
                    34,
                    42,
                    30,
                    5,
                    12,
                    48,
                    44
                ],
                "channel": [
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    0,
                    1,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    1
                ],
                "coefs": [
                    1.822265625,
                    -1.2744140625,
                    -1.142578125,
                    -0.64404296875,
                    0.1422119140625,
                    -0.64453125,
                    -0.09808349609375,
                    -1.2958984375,
                    -0.443603515625,
                    0.134033203125,
                    0.439453125,
                    -0.1859130859375,
                    -0.10980224609375,
                    -0.21630859375,
                    0.8037109375,
                    -0.447021484375,
                    -0.6201171875,
                    -0.215087890625,
                    -0.0292816162109375,
                    0.375244140625,
                    0.005908966064453125,
                    0.53125,
                    -0.97119140625,
                    1.701171875,
                    -0.81396484375,
                    -0.47509765625,
                    -0.818359375,
                    -0.09393310546875,
                    -0.73046875,
                    0.64990234375,
                    -0.634765625,
                    -0.251220703125,
                    -0.61279296875,
                    1.67578125,
                    -0.86474609375,
                    -0.72998046875,
                    0.1451416015625,
                    -0.123291015625,
                    -0.474853515625,
                    0.505859375,
                    0.146728515625,
                    -0.424072265625,
                    -1.4296875,
                    0.841796875,
                    0.8408203125,
                    -0.135498046875,
                    -0.357177734375,
                    -0.51953125,
                    0.626953125,
                    1.33984375,
                    0.81005859375,
                    -0.38330078125,
                    -0.97265625,
                    -0.1527099609375,
                    -0.1812744140625,
                    0.360107421875,
                    0.47216796875,
                    -0.326416015625,
                    -0.361083984375,
                    -0.33642578125,
                    -0.5283203125,
                    0.291259765625,
                    0.556640625,
                    -0.265625,
                    0.12115478515625,
                    0.371826171875,
                    -0.5732421875,
                    -0.466552734375,
                    0.411376953125,
                    -0.53564453125,
                    -0.27587890625,
                    -0.10540771484375,
                    0.26611328125,
                    -0.55712890625,
                    -0.29541015625,
                    0.37646484375,
                    -0.2880859375
                ],
                "intercept": -72.9375,
                "mean": 97.82598437858066
            }
        },
        "m_canvas_draw_all": {
            "m_canvas_draw_all_fisher_10": {
                "x": [
                    208,
                    36,
                    119,
                    83,
                    115,
                    78,
                    161,
                    27,
                    9,
                    174,
                    154,
                    227,
                    104,
                    203,
                    194,
                    194,
                    121,
                    21,
                    56,
                    18,
                    216,
                    107,
                    124,
                    44,
                    53,
                    158,
                    7,
                    28,
                    144,
                    190,
                    191,
                    26,
                    17,
                    192,
                    174,
                    12,
                    213,
                    160,
                    153,
                    117,
                    47,
                    117,
                    194,
                    234,
                    223,
                    62,
                    5,
                    192,
                    184,
                    6,
                    162,
                    191,
                    53,
                    189,
                    56,
                    26,
                    28,
                    0,
                    150,
                    18,
                    94,
                    45,
                    206,
                    205,
                    214,
                    168,
                    17,
                    64,
                    0,
                    102,
                    17,
                    177,
                    106,
                    56,
                    135,
                    220,
                    159,
                    4,
                    130,
                    109,
                    121,
                    18,
                    208,
                    113,
                    120,
                    146,
                    110,
                    145,
                    160,
                    106,
                    31,
                    146,
                    22,
                    190,
                    232,
                    206,
                    102,
                    127,
                    15,
                    193,
                    195,
                    118,
                    105,
                    19,
                    129,
                    80,
                    30,
                    88,
                    213,
                    167,
                    54,
                    15,
                    4,
                    220,
                    74,
                    103,
                    57,
                    122,
                    125,
                    49,
                    46,
                    210,
                    14,
                    101,
                    0,
                    151,
                    24,
                    173,
                    193,
                    109,
                    124,
                    7,
                    51,
                    54,
                    51,
                    111,
                    7,
                    37,
                    0,
                    84,
                    75,
                    110,
                    49,
                    106,
                    84,
                    3,
                    30,
                    139,
                    205,
                    208,
                    129,
                    23,
                    95,
                    151,
                    23,
                    131,
                    26,
                    219,
                    143,
                    16,
                    132,
                    18,
                    217,
                    24,
                    213,
                    37,
                    133,
                    217,
                    204,
                    219,
                    11,
                    106,
                    21,
                    29,
                    75,
                    7,
                    49,
                    9,
                    210,
                    14,
                    78,
                    3,
                    1,
                    2,
                    214,
                    200,
                    53,
                    4,
                    193,
                    151,
                    160,
                    198,
                    194,
                    55,
                    2,
                    17,
                    104,
                    61,
                    161,
                    158,
                    19,
                    11,
                    24,
                    1,
                    95,
                    194,
                    190,
                    183,
                    6,
                    12,
                    214,
                    209,
                    116,
                    205,
                    9,
                    168,
                    194,
                    198,
                    133,
                    118,
                    19,
                    214,
                    131,
                    3,
                    11,
                    144,
                    12,
                    164,
                    19,
                    113,
                    216,
                    87,
                    19,
                    114,
                    31,
                    127,
                    2,
                    17,
                    0,
                    161,
                    222,
                    221,
                    14,
                    20,
                    57,
                    8,
                    186,
                    15,
                    214,
                    102,
                    84,
                    109,
                    86,
                    149,
                    216,
                    188,
                    7,
                    112,
                    207,
                    11,
                    193,
                    203,
                    151,
                    157,
                    219,
                    24,
                    196,
                    46,
                    24,
                    56,
                    198,
                    10,
                    198,
                    27,
                    191,
                    134,
                    207,
                    16,
                    12,
                    50,
                    64,
                    106,
                    172,
                    15,
                    207,
                    9,
                    63,
                    66,
                    229,
                    103,
                    81,
                    118,
                    222,
                    205,
                    163,
                    144,
                    224,
                    81,
                    11,
                    72,
                    59,
                    129,
                    196,
                    7,
                    129,
                    27,
                    220,
                    202,
                    19,
                    78,
                    207,
                    214,
                    207,
                    13,
                    217,
                    6,
                    208,
                    23,
                    9,
                    10,
                    168,
                    184,
                    212,
                    211,
                    26,
                    205,
                    51,
                    227,
                    205,
                    200,
                    49,
                    211,
                    174,
                    22,
                    27,
                    207,
                    18,
                    174,
                    21,
                    14,
                    210,
                    115,
                    127,
                    193,
                    25,
                    142,
                    4,
                    10,
                    55,
                    7,
                    86,
                    204,
                    24,
                    9,
                    18,
                    181,
                    113,
                    18,
                    195,
                    197,
                    5,
                    50,
                    74,
                    215,
                    73,
                    202,
                    8,
                    221,
                    218,
                    196,
                    62,
                    127,
                    11,
                    53,
                    212,
                    223,
                    34,
                    193,
                    220,
                    207,
                    196,
                    105,
                    162,
                    197,
                    7,
                    114,
                    215,
                    167,
                    155,
                    93,
                    223,
                    87,
                    159,
                    193,
                    215,
                    210,
                    152,
                    185,
                    54,
                    145,
                    146,
                    16,
                    207,
                    202,
                    200,
                    9,
                    75,
                    112,
                    107,
                    50,
                    58,
                    16,
                    211,
                    145,
                    153,
                    30,
                    156,
                    125,
                    101,
                    149,
                    216,
                    218,
                    6,
                    132,
                    111,
                    209,
                    199,
                    174,
                    17,
                    2,
                    14,
                    13,
                    155,
                    192,
                    29,
                    186,
                    91,
                    12,
                    61,
                    103,
                    66,
                    143,
                    206
                ],
                "y": [
                    89,
                    199,
                    119,
                    89,
                    95,
                    90,
                    86,
                    92,
                    235,
                    78,
                    81,
                    95,
                    132,
                    90,
                    50,
                    46,
                    96,
                    217,
                    92,
                    221,
                    101,
                    134,
                    13,
                    98,
                    96,
                    83,
                    235,
                    222,
                    91,
                    54,
                    58,
                    217,
                    215,
                    44,
                    66,
                    232,
                    89,
                    78,
                    84,
                    93,
                    94,
                    90,
                    45,
                    90,
                    91,
                    172,
                    240,
                    60,
                    52,
                    236,
                    78,
                    46,
                    93,
                    45,
                    91,
                    213,
                    211,
                    70,
                    86,
                    224,
                    151,
                    202,
                    32,
                    43,
                    98,
                    68,
                    219,
                    179,
                    246,
                    138,
                    221,
                    67,
                    88,
                    89,
                    0,
                    98,
                    75,
                    232,
                    17,
                    133,
                    92,
                    217,
                    97,
                    90,
                    93,
                    95,
                    98,
                    89,
                    84,
                    133,
                    216,
                    94,
                    3,
                    44,
                    90,
                    95,
                    91,
                    4,
                    223,
                    43,
                    50,
                    90,
                    95,
                    219,
                    117,
                    94,
                    210,
                    94,
                    94,
                    78,
                    92,
                    232,
                    234,
                    93,
                    91,
                    132,
                    92,
                    98,
                    114,
                    189,
                    99,
                    38,
                    230,
                    133,
                    30,
                    83,
                    214,
                    70,
                    46,
                    94,
                    5,
                    234,
                    191,
                    100,
                    96,
                    90,
                    238,
                    201,
                    49,
                    95,
                    166,
                    129,
                    97,
                    134,
                    88,
                    241,
                    221,
                    103,
                    89,
                    95,
                    116,
                    217,
                    150,
                    93,
                    218,
                    111,
                    97,
                    35,
                    92,
                    234,
                    0,
                    225,
                    99,
                    99,
                    91,
                    205,
                    4,
                    96,
                    91,
                    99,
                    231,
                    135,
                    217,
                    210,
                    171,
                    239,
                    95,
                    237,
                    33,
                    101,
                    99,
                    236,
                    249,
                    248,
                    27,
                    35,
                    184,
                    232,
                    47,
                    82,
                    85,
                    51,
                    52,
                    93,
                    248,
                    225,
                    133,
                    189,
                    75,
                    77,
                    216,
                    240,
                    89,
                    239,
                    153,
                    51,
                    52,
                    56,
                    237,
                    230,
                    99,
                    93,
                    96,
                    98,
                    241,
                    77,
                    55,
                    53,
                    114,
                    89,
                    222,
                    96,
                    17,
                    242,
                    241,
                    96,
                    240,
                    79,
                    221,
                    97,
                    99,
                    98,
                    99,
                    91,
                    211,
                    115,
                    242,
                    218,
                    247,
                    76,
                    99,
                    95,
                    233,
                    99,
                    94,
                    239,
                    57,
                    231,
                    94,
                    97,
                    153,
                    96,
                    95,
                    94,
                    93,
                    60,
                    238,
                    94,
                    91,
                    229,
                    96,
                    46,
                    87,
                    89,
                    96,
                    217,
                    52,
                    191,
                    216,
                    97,
                    50,
                    228,
                    42,
                    95,
                    53,
                    5,
                    98,
                    220,
                    239,
                    97,
                    178,
                    94,
                    67,
                    235,
                    98,
                    229,
                    175,
                    177,
                    91,
                    93,
                    98,
                    94,
                    97,
                    95,
                    78,
                    97,
                    18,
                    94,
                    230,
                    93,
                    186,
                    115,
                    37,
                    236,
                    117,
                    211,
                    89,
                    98,
                    220,
                    91,
                    97,
                    33,
                    94,
                    230,
                    98,
                    234,
                    35,
                    214,
                    227,
                    231,
                    70,
                    58,
                    94,
                    33,
                    216,
                    93,
                    97,
                    18,
                    90,
                    47,
                    98,
                    33,
                    68,
                    3,
                    97,
                    36,
                    220,
                    74,
                    214,
                    232,
                    90,
                    96,
                    117,
                    97,
                    94,
                    106,
                    234,
                    227,
                    95,
                    240,
                    98,
                    99,
                    213,
                    235,
                    234,
                    61,
                    93,
                    215,
                    38,
                    41,
                    237,
                    90,
                    99,
                    93,
                    96,
                    38,
                    236,
                    97,
                    93,
                    38,
                    176,
                    109,
                    239,
                    96,
                    26,
                    99,
                    202,
                    47,
                    97,
                    32,
                    52,
                    132,
                    86,
                    44,
                    239,
                    96,
                    96,
                    68,
                    86,
                    156,
                    88,
                    94,
                    89,
                    45,
                    29,
                    32,
                    85,
                    94,
                    91,
                    96,
                    94,
                    216,
                    90,
                    46,
                    38,
                    238,
                    159,
                    133,
                    98,
                    98,
                    95,
                    224,
                    35,
                    90,
                    86,
                    209,
                    89,
                    115,
                    135,
                    94,
                    94,
                    96,
                    239,
                    112,
                    96,
                    32,
                    43,
                    68,
                    219,
                    248,
                    230,
                    232,
                    88,
                    47,
                    214,
                    60,
                    143,
                    234,
                    188,
                    98,
                    93,
                    91,
                    89
                ],
                "channel": [
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    1,
                    0,
                    1,
                    2,
                    1,
                    1,
                    2,
                    1,
                    0,
                    2,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1,
                    2,
                    0,
                    0,
                    1,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    1,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    1,
                    2,
                    1,
                    0,
                    1,
                    0,
                    2,
                    1,
                    1,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    1,
                    0,
                    1,
                    0,
                    1,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    1,
                    0,
                    2,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    1,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    2,
                    1,
                    1,
                    2,
                    2,
                    0,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    2,
                    0,
                    0,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    0,
                    0,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    1,
                    2,
                    1,
                    0,
                    1,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    1,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    1,
                    1,
                    0,
                    2,
                    2,
                    1,
                    2,
                    1,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    1,
                    2,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    1,
                    2,
                    1,
                    1,
                    0,
                    2,
                    1,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    2,
                    0,
                    0,
                    0,
                    1,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    2,
                    0,
                    1,
                    0,
                    2,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    0,
                    1,
                    1,
                    1,
                    0,
                    1,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    1,
                    1,
                    2,
                    2,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    2,
                    0,
                    2,
                    1,
                    0,
                    1,
                    2,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    2,
                    1,
                    1,
                    1,
                    0,
                    2,
                    2,
                    1,
                    0,
                    0,
                    1,
                    2,
                    1,
                    0,
                    1,
                    0,
                    2,
                    1,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    1,
                    1,
                    2,
                    0,
                    1,
                    1,
                    1,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    1,
                    1,
                    2,
                    0
                ],
                "coefs": [
                    -1.486328125,
                    0.6875,
                    1.0185546875,
                    1.1318359375,
                    -2.1796875,
                    -3.2890625,
                    -0.002826690673828125,
                    5.10546875,
                    1.291015625,
                    0.62890625,
                    0.619140625,
                    -0.073974609375,
                    1.53125,
                    0.55322265625,
                    0.96923828125,
                    -0.79931640625,
                    4.33984375,
                    0.86083984375,
                    1.740234375,
                    -0.0865478515625,
                    3.240234375,
                    0.94775390625,
                    1.982421875,
                    4.8359375,
                    2.587890625,
                    -0.35546875,
                    -0.63671875,
                    1.0224609375,
                    3.0390625,
                    1.3427734375,
                    0.021148681640625,
                    2.431640625,
                    -1.0068359375,
                    0.70849609375,
                    0.55224609375,
                    -2.44921875,
                    -1.8359375,
                    2.21484375,
                    -0.2666015625,
                    1.5615234375,
                    -0.78369140625,
                    4.95703125,
                    -0.849609375,
                    0.54443359375,
                    2.11328125,
                    4.3203125,
                    -0.1414794921875,
                    3.029296875,
                    3.4296875,
                    0.49169921875,
                    1.173828125,
                    -0.80615234375,
                    2.640625,
                    3.814453125,
                    2.72265625,
                    0.431396484375,
                    1.8740234375,
                    0.025360107421875,
                    4.08203125,
                    0.5439453125,
                    1.3037109375,
                    -0.261474609375,
                    -1.224609375,
                    0.36572265625,
                    -0.2841796875,
                    -0.84130859375,
                    -0.1112060546875,
                    -1.41796875,
                    0.0166778564453125,
                    0.30517578125,
                    -0.6669921875,
                    0.183837890625,
                    1.310546875,
                    -6.609375,
                    0.75048828125,
                    -4.11328125,
                    2.392578125,
                    -0.389404296875,
                    -1.3251953125,
                    -1.3544921875,
                    -0.040618896484375,
                    -0.1063232421875,
                    0.0897216796875,
                    3.671875,
                    -0.61865234375,
                    1.8076171875,
                    1.2548828125,
                    0.86328125,
                    1.1083984375,
                    -0.39990234375,
                    -0.52880859375,
                    0.41796875,
                    -1.1474609375,
                    1.9296875,
                    3.470703125,
                    6.57421875,
                    2.0546875,
                    1.2626953125,
                    -1.1318359375,
                    -0.57568359375,
                    0.5126953125,
                    7.78515625,
                    3.751953125,
                    0.611328125,
                    2.626953125,
                    -0.228271484375,
                    -0.953125,
                    0.334716796875,
                    -0.445068359375,
                    -2.7734375,
                    0.572265625,
                    -0.0982666015625,
                    1.1884765625,
                    1.7451171875,
                    1.689453125,
                    -0.177978515625,
                    5.3125,
                    4.64453125,
                    -1.8623046875,
                    -2.162109375,
                    4.3359375,
                    0.215576171875,
                    -0.07537841796875,
                    -1.1396484375,
                    0.43994140625,
                    0.2213134765625,
                    -0.284423828125,
                    0.70166015625,
                    0.32421875,
                    1.0908203125,
                    -1.5712890625,
                    0.34033203125,
                    -0.943359375,
                    2.009765625,
                    -2.3125,
                    2.580078125,
                    0.07244873046875,
                    0.94384765625,
                    -0.0135498046875,
                    3.6796875,
                    -1.5634765625,
                    1.15625,
                    -0.8916015625,
                    -0.42138671875,
                    4.49609375,
                    1.125,
                    2.14453125,
                    -1.1826171875,
                    -4.15625,
                    -3.40625,
                    -0.307373046875,
                    1.4541015625,
                    -0.8662109375,
                    0.1446533203125,
                    -1.0517578125,
                    2.59765625,
                    1.4248046875,
                    0.8046875,
                    0.28271484375,
                    1.125,
                    0.87255859375,
                    -0.27294921875,
                    1.923828125,
                    -2.654296875,
                    -1.4306640625,
                    -0.9453125,
                    -1.33984375,
                    0.58349609375,
                    6.859375,
                    1.3447265625,
                    1.1513671875,
                    1.037109375,
                    -2.326171875,
                    1.4599609375,
                    1.2119140625,
                    0.10723876953125,
                    -3.244140625,
                    1.9853515625,
                    -1.1337890625,
                    -1.708984375,
                    3.677734375,
                    0.376220703125,
                    0.484619140625,
                    -0.53369140625,
                    0.01061248779296875,
                    0.11895751953125,
                    -0.10418701171875,
                    0.59326171875,
                    -1.3271484375,
                    5.8515625,
                    -0.6748046875,
                    -0.412841796875,
                    1.001953125,
                    2.3203125,
                    -0.1351318359375,
                    0.310791015625,
                    0.130615234375,
                    2.1171875,
                    0.8310546875,
                    1.076171875,
                    0.76220703125,
                    0.4150390625,
                    -3.619140625,
                    0.10400390625,
                    0.2529296875,
                    -2.5,
                    -0.5078125,
                    4.09375,
                    0.344482421875,
                    1.8017578125,
                    -1.869140625,
                    4.9375,
                    -1.6533203125,
                    3.091796875,
                    -1.1494140625,
                    0.275634765625,
                    -0.3935546875,
                    -0.373291015625,
                    3.361328125,
                    3.33203125,
                    -0.0012044906616210938,
                    0.89697265625,
                    1.6171875,
                    -0.058563232421875,
                    -0.2186279296875,
                    -0.66015625,
                    1.0888671875,
                    -1.08984375,
                    0.62841796875,
                    -0.89794921875,
                    3.845703125,
                    4.2890625,
                    -0.351318359375,
                    4.11328125,
                    2.70703125,
                    -0.233154296875,
                    0.285888671875,
                    -0.62255859375,
                    0.0648193359375,
                    -0.9736328125,
                    5.1171875,
                    -2.521484375,
                    -0.4208984375,
                    -0.384765625,
                    3.09375,
                    0.54345703125,
                    0.1595458984375,
                    -0.127685546875,
                    0.467529296875,
                    4.47265625,
                    0.372802734375,
                    -1.591796875,
                    1.4404296875,
                    1.00390625,
                    1.5439453125,
                    -1.3359375,
                    0.034912109375,
                    -1.455078125,
                    8.53125,
                    -1.0078125,
                    -0.51953125,
                    -0.126953125,
                    -4.078125,
                    0.7685546875,
                    -0.77099609375,
                    -0.55810546875,
                    -1.01171875,
                    -1.49609375,
                    0.32275390625,
                    -0.34423828125,
                    -1.2958984375,
                    0.436767578125,
                    -3.072265625,
                    2.111328125,
                    -1.5556640625,
                    2.046875,
                    29.421875,
                    -0.20166015625,
                    -1.2353515625,
                    0.80419921875,
                    1.8134765625,
                    2.685546875,
                    0.057830810546875,
                    0.1085205078125,
                    -17.984375,
                    -0.141845703125,
                    1.1376953125,
                    1.03125,
                    -0.382568359375,
                    -3.28515625,
                    -2.94140625,
                    -3.95703125,
                    -1.294921875,
                    2.19140625,
                    -0.1864013671875,
                    -1.0654296875,
                    0.72900390625,
                    -4.4140625,
                    -1.697265625,
                    4.140625,
                    0.478271484375,
                    0.79638671875,
                    0.2900390625,
                    -0.046295166015625,
                    0.28515625,
                    -1.1240234375,
                    4.234375,
                    1.6875,
                    -1.5009765625,
                    -0.74658203125,
                    6.18359375,
                    0.1783447265625,
                    -1.7822265625,
                    0.471435546875,
                    4.83984375,
                    0.88818359375,
                    1.84375,
                    0.270263671875,
                    1.759765625,
                    0.2213134765625,
                    -0.0867919921875,
                    1.4521484375,
                    2.68359375,
                    1.2841796875,
                    -1.94921875,
                    0.90478515625,
                    0.318115234375,
                    -0.248046875,
                    -0.90087890625,
                    -1.029296875,
                    -2.333984375,
                    -1.2177734375,
                    -0.489990234375,
                    1.20703125,
                    -3,
                    0.400146484375,
                    -0.06329345703125,
                    0.85107421875,
                    0.96435546875,
                    0.0792236328125,
                    -2.306640625,
                    2.666015625,
                    -1.65625,
                    0.78076171875,
                    -1.125,
                    1.8212890625,
                    1.5732421875,
                    0.58056640625,
                    0.342041015625,
                    -0.1614990234375,
                    2.01171875,
                    5.484375,
                    1.451171875,
                    -0.4423828125,
                    -0.0095977783203125,
                    -0.1513671875,
                    -1.2421875,
                    1.173828125,
                    1.1171875,
                    2.150390625,
                    -1.26953125,
                    -3.4453125,
                    -1.0751953125,
                    3.03515625,
                    1.783203125,
                    0.59130859375,
                    -1.3642578125,
                    -2.380859375,
                    -3.59765625,
                    0.70947265625,
                    1.697265625,
                    -5.55859375,
                    -0.74267578125,
                    -2.763671875,
                    0.449462890625,
                    0.404541015625,
                    2.712890625,
                    1.9404296875,
                    -2.466796875,
                    -0.75927734375,
                    -0.68017578125,
                    -1.013671875,
                    0.028106689453125,
                    -0.4208984375,
                    -1.326171875,
                    -2.076171875,
                    2.71484375,
                    -0.67138671875,
                    -3.669921875,
                    -0.4755859375,
                    -3.3515625,
                    0.650390625,
                    0.736328125,
                    1.1318359375,
                    0.414794921875,
                    0.54296875,
                    3.072265625,
                    -0.73193359375,
                    3.720703125,
                    0.70068359375,
                    -0.8681640625,
                    1.04296875,
                    -2.31640625,
                    0.419677734375,
                    0.87158203125,
                    -0.2342529296875,
                    0.2939453125,
                    0.135498046875,
                    1.2529296875,
                    -1.2294921875,
                    -1.7958984375,
                    0.08599853515625,
                    0.3994140625,
                    -2.025390625,
                    -2.505859375,
                    1.234375,
                    -1.38671875,
                    1.349609375,
                    1.14453125,
                    -1.505859375,
                    1.5966796875,
                    2.369140625,
                    1.2109375,
                    1.6171875,
                    1.4755859375,
                    1.5791015625,
                    1.4150390625,
                    0.38525390625,
                    1.24609375,
                    0.418212890625,
                    0.83935546875,
                    -1.3662109375,
                    1.4921875,
                    0.8564453125,
                    -0.82763671875,
                    1.177734375,
                    0.89599609375,
                    -0.44189453125,
                    -0.41455078125,
                    -0.98193359375,
                    0.7421875,
                    -0.65087890625,
                    -0.88623046875
                ],
                "intercept": 14.5703125,
                "mean": 26653.003385977434
            },
            "m_canvas_draw_all_fisher_12": {
                "x": [
                    156,
                    221,
                    224,
                    67,
                    4,
                    107,
                    106,
                    5,
                    108,
                    61,
                    21,
                    104,
                    100,
                    228,
                    17,
                    59,
                    198,
                    224,
                    76,
                    138,
                    209,
                    127,
                    203,
                    134,
                    104,
                    89,
                    208,
                    117,
                    4,
                    26,
                    104,
                    31,
                    218,
                    222,
                    85,
                    55,
                    57,
                    107,
                    117,
                    0,
                    145,
                    209,
                    188,
                    25,
                    163,
                    18,
                    111,
                    73,
                    50,
                    89,
                    65,
                    53,
                    19,
                    155,
                    151,
                    6,
                    5,
                    128,
                    7,
                    153,
                    115,
                    57,
                    124,
                    17,
                    206,
                    214,
                    18,
                    116,
                    214,
                    10,
                    128,
                    205,
                    203,
                    125,
                    222,
                    91,
                    90,
                    87,
                    206,
                    7,
                    5,
                    165,
                    115,
                    109,
                    133,
                    18,
                    112,
                    126,
                    123,
                    148,
                    144,
                    43,
                    107,
                    107,
                    220,
                    211,
                    210,
                    8,
                    36,
                    119,
                    120,
                    212,
                    102,
                    124,
                    90,
                    14,
                    55,
                    129,
                    9,
                    3,
                    4,
                    6,
                    24,
                    124,
                    91,
                    227,
                    129,
                    228,
                    170,
                    94,
                    125,
                    6,
                    150,
                    50,
                    108,
                    63,
                    86,
                    107,
                    163,
                    125,
                    19,
                    116,
                    147,
                    56,
                    208,
                    221,
                    189,
                    111,
                    89,
                    134,
                    21,
                    58,
                    88,
                    79,
                    59,
                    175,
                    147,
                    178,
                    149,
                    5,
                    157,
                    207,
                    50,
                    117,
                    142,
                    129,
                    60,
                    160,
                    153,
                    34,
                    19,
                    120,
                    122,
                    220,
                    224,
                    52,
                    213,
                    63,
                    136,
                    178,
                    21,
                    151,
                    164,
                    86,
                    119,
                    92,
                    220,
                    106,
                    3,
                    121,
                    212,
                    111,
                    208,
                    6,
                    227,
                    220,
                    19,
                    57,
                    27,
                    92,
                    132,
                    129,
                    18,
                    158,
                    118,
                    115,
                    24,
                    174,
                    134,
                    113,
                    125,
                    120,
                    4,
                    134,
                    74,
                    3,
                    157,
                    150,
                    124,
                    44,
                    37,
                    29,
                    148,
                    160,
                    122,
                    18,
                    61,
                    86,
                    147,
                    44,
                    77,
                    121,
                    2,
                    43,
                    122,
                    103,
                    220,
                    29,
                    15,
                    215,
                    151,
                    129,
                    221,
                    65,
                    61,
                    212,
                    102,
                    132,
                    164,
                    178,
                    152,
                    213,
                    122,
                    205,
                    120,
                    129,
                    106,
                    149,
                    5,
                    158,
                    201,
                    208,
                    43,
                    147,
                    112,
                    0,
                    149,
                    45,
                    134,
                    4,
                    224,
                    206,
                    167,
                    132,
                    52,
                    131,
                    211,
                    8,
                    198,
                    7,
                    170,
                    203,
                    205,
                    24,
                    30,
                    145,
                    88,
                    64,
                    6,
                    116,
                    124,
                    131,
                    209,
                    208,
                    217,
                    75,
                    42,
                    117,
                    220,
                    198,
                    108,
                    221,
                    222,
                    5,
                    77,
                    88,
                    147,
                    9,
                    82,
                    109,
                    53,
                    106,
                    129,
                    120,
                    31,
                    221,
                    138,
                    36,
                    153,
                    106,
                    62,
                    5,
                    101,
                    7,
                    19,
                    207,
                    124,
                    54,
                    140,
                    7,
                    199,
                    17,
                    133,
                    135
                ],
                "y": [
                    7,
                    98,
                    99,
                    183,
                    237,
                    99,
                    15,
                    240,
                    142,
                    181,
                    219,
                    140,
                    14,
                    97,
                    221,
                    191,
                    44,
                    95,
                    99,
                    18,
                    101,
                    7,
                    152,
                    117,
                    139,
                    156,
                    34,
                    17,
                    234,
                    90,
                    8,
                    220,
                    91,
                    97,
                    90,
                    96,
                    92,
                    18,
                    93,
                    98,
                    8,
                    38,
                    55,
                    221,
                    75,
                    221,
                    89,
                    93,
                    100,
                    151,
                    179,
                    93,
                    219,
                    11,
                    17,
                    6,
                    241,
                    7,
                    236,
                    95,
                    90,
                    90,
                    6,
                    220,
                    98,
                    98,
                    218,
                    8,
                    94,
                    242,
                    13,
                    154,
                    150,
                    113,
                    158,
                    147,
                    155,
                    89,
                    95,
                    238,
                    242,
                    19,
                    130,
                    11,
                    20,
                    217,
                    7,
                    16,
                    12,
                    92,
                    12,
                    12,
                    8,
                    94,
                    99,
                    98,
                    93,
                    238,
                    198,
                    89,
                    91,
                    95,
                    95,
                    19,
                    148,
                    237,
                    90,
                    14,
                    241,
                    239,
                    238,
                    239,
                    222,
                    4,
                    153,
                    90,
                    19,
                    159,
                    72,
                    151,
                    14,
                    240,
                    93,
                    12,
                    130,
                    180,
                    99,
                    141,
                    80,
                    7,
                    214,
                    90,
                    93,
                    98,
                    31,
                    95,
                    56,
                    141,
                    153,
                    16,
                    220,
                    96,
                    97,
                    98,
                    190,
                    141,
                    95,
                    98,
                    96,
                    236,
                    10,
                    152,
                    98,
                    20,
                    18,
                    12,
                    182,
                    18,
                    18,
                    8,
                    221,
                    99,
                    95,
                    89,
                    90,
                    8,
                    99,
                    181,
                    94,
                    99,
                    220,
                    19,
                    16,
                    92,
                    119,
                    153,
                    95,
                    89,
                    234,
                    14,
                    95,
                    90,
                    32,
                    238,
                    94,
                    89,
                    218,
                    95,
                    94,
                    156,
                    112,
                    13,
                    221,
                    11,
                    95,
                    99,
                    97,
                    141,
                    19,
                    128,
                    109,
                    119,
                    241,
                    18,
                    98,
                    236,
                    99,
                    95,
                    13,
                    5,
                    14,
                    213,
                    20,
                    134,
                    89,
                    215,
                    181,
                    152,
                    13,
                    95,
                    90,
                    12,
                    235,
                    5,
                    97,
                    138,
                    96,
                    217,
                    237,
                    97,
                    18,
                    11,
                    94,
                    180,
                    184,
                    90,
                    12,
                    12,
                    15,
                    99,
                    3,
                    100,
                    18,
                    97,
                    91,
                    15,
                    14,
                    15,
                    7,
                    18,
                    152,
                    37,
                    13,
                    19,
                    90,
                    233,
                    92,
                    8,
                    8,
                    239,
                    94,
                    150,
                    69,
                    11,
                    10,
                    20,
                    97,
                    238,
                    148,
                    239,
                    72,
                    148,
                    153,
                    89,
                    215,
                    16,
                    148,
                    180,
                    241,
                    136,
                    119,
                    13,
                    92,
                    98,
                    97,
                    97,
                    14,
                    14,
                    97,
                    96,
                    20,
                    101,
                    94,
                    241,
                    91,
                    94,
                    92,
                    241,
                    152,
                    92,
                    98,
                    96,
                    18,
                    97,
                    219,
                    101,
                    7,
                    12,
                    94,
                    97,
                    188,
                    237,
                    8,
                    237,
                    222,
                    90,
                    12,
                    8,
                    18,
                    240,
                    149,
                    220,
                    112,
                    12
                ],
                "channel": [
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    1,
                    2,
                    2,
                    1,
                    2,
                    2,
                    1,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    1,
                    0,
                    2,
                    1,
                    1,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    1,
                    1,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    2,
                    1,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    1,
                    2,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    1,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    1,
                    1,
                    1,
                    2,
                    1,
                    0,
                    1,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0
                ],
                "coefs": [
                    -6.05859375,
                    -1.072265625,
                    0.397216796875,
                    1.8623046875,
                    0.75146484375,
                    -2.6796875,
                    -1.4140625,
                    -0.1456298828125,
                    -1.390625,
                    0.46533203125,
                    -0.75634765625,
                    -0.0797119140625,
                    0.50927734375,
                    2.134765625,
                    0.1336669921875,
                    -1.0400390625,
                    -0.96923828125,
                    0.68798828125,
                    2.69140625,
                    1.4365234375,
                    1.5,
                    -0.86474609375,
                    -0.1351318359375,
                    -1.2197265625,
                    -0.99462890625,
                    -0.720703125,
                    -0.56298828125,
                    -1.052734375,
                    0.50244140625,
                    1.033203125,
                    -0.10540771484375,
                    -1.1806640625,
                    -1.361328125,
                    -2.16015625,
                    -2.8125,
                    -1.2001953125,
                    -0.70166015625,
                    -0.57958984375,
                    -2.12109375,
                    -1.1357421875,
                    -1.3779296875,
                    -0.343017578125,
                    0.2470703125,
                    0.465576171875,
                    0.046356201171875,
                    0.4462890625,
                    -0.445556640625,
                    -1.58984375,
                    -1.078125,
                    -1.44140625,
                    -1.103515625,
                    0.412109375,
                    0.01107025146484375,
                    -4.4375,
                    -1.8125,
                    0.1531982421875,
                    0.384521484375,
                    1.912109375,
                    0.16650390625,
                    -1.2470703125,
                    0.67578125,
                    1.498046875,
                    -1.8408203125,
                    0.1314697265625,
                    -2.27734375,
                    -2.484375,
                    0.07147216796875,
                    -1.8212890625,
                    -2.177734375,
                    1.6767578125,
                    -1.3115234375,
                    -0.77001953125,
                    -0.2393798828125,
                    -1.765625,
                    -0.59521484375,
                    1.4609375,
                    -0.80322265625,
                    2.748046875,
                    -1.140625,
                    0.058135986328125,
                    1.3515625,
                    -0.70947265625,
                    -0.79248046875,
                    2.17578125,
                    -0.179443359375,
                    0.370361328125,
                    -1.396484375,
                    1.4287109375,
                    -0.328857421875,
                    -0.66748046875,
                    -0.810546875,
                    -0.73828125,
                    0.3095703125,
                    0.4443359375,
                    -1.400390625,
                    -1.6640625,
                    -1.71875,
                    1.0732421875,
                    -1.0107421875,
                    -3.69921875,
                    -4.58203125,
                    -0.428955078125,
                    -1.23046875,
                    -1.2578125,
                    1.02734375,
                    -1.22265625,
                    1.875,
                    -0.76416015625,
                    -0.1949462890625,
                    0.095703125,
                    -0.763671875,
                    0.458740234375,
                    0.1378173828125,
                    -3.07421875,
                    0.7236328125,
                    -4.25390625,
                    1.9775390625,
                    -0.60400390625,
                    -0.26611328125,
                    -1.013671875,
                    -2.244140625,
                    -0.39404296875,
                    -1.2783203125,
                    -0.134033203125,
                    -0.492919921875,
                    -1.3583984375,
                    -1.0244140625,
                    -1.61328125,
                    0.131103515625,
                    -0.409912109375,
                    0.0489501953125,
                    -3.494140625,
                    -0.26611328125,
                    -0.60546875,
                    -1.2646484375,
                    -0.90625,
                    -0.329345703125,
                    -1.8203125,
                    -1.1748046875,
                    3.203125,
                    1.4384765625,
                    1.7236328125,
                    -1.2080078125,
                    1.7587890625,
                    -1.427734375,
                    -0.60986328125,
                    0.05975341796875,
                    -0.2435302734375,
                    -0.8623046875,
                    -0.53466796875,
                    -3.892578125,
                    0.4501953125,
                    -1.896484375,
                    1.38671875,
                    0.9951171875,
                    -1.0927734375,
                    -0.316650390625,
                    1.234375,
                    0.3212890625,
                    -1.3115234375,
                    -0.362060546875,
                    1.51171875,
                    -1.5673828125,
                    -3.49609375,
                    3.91015625,
                    -1.6298828125,
                    -0.66162109375,
                    -1.84375,
                    1.001953125,
                    -10.046875,
                    0.5390625,
                    0.31591796875,
                    0.30712890625,
                    2.7890625,
                    -1.029296875,
                    0.50341796875,
                    1.6328125,
                    -0.67333984375,
                    -0.609375,
                    -0.61767578125,
                    -3.72265625,
                    -2.203125,
                    0.302734375,
                    -0.78955078125,
                    -1.951171875,
                    -2.3984375,
                    -0.72265625,
                    1.52734375,
                    -0.81884765625,
                    -0.94775390625,
                    1.734375,
                    1.7060546875,
                    -0.0869140625,
                    -1.4501953125,
                    -1.7060546875,
                    1.6953125,
                    -0.402587890625,
                    0.455322265625,
                    0.75048828125,
                    1.263671875,
                    -1.9970703125,
                    0.48486328125,
                    0.201904296875,
                    0.1712646484375,
                    2.43359375,
                    1.447265625,
                    -0.02166748046875,
                    0.7353515625,
                    1.322265625,
                    -1.4228515625,
                    -1.3408203125,
                    -0.69873046875,
                    -0.744140625,
                    -0.84423828125,
                    2.1015625,
                    0.5087890625,
                    -1.7607421875,
                    -1.7294921875,
                    -2.177734375,
                    -1.8369140625,
                    -0.8955078125,
                    -1.5068359375,
                    -0.33837890625,
                    -0.1497802734375,
                    -1.5830078125,
                    1.1220703125,
                    2.31640625,
                    1.8564453125,
                    0.62060546875,
                    -0.2344970703125,
                    0.58837890625,
                    1.0546875,
                    -0.57275390625,
                    -1.17578125,
                    -1.83984375,
                    -2.68359375,
                    1.8642578125,
                    1.0009765625,
                    -0.10162353515625,
                    -8.671875,
                    -1.728515625,
                    -1.951171875,
                    -1.09765625,
                    0.5546875,
                    -2.359375,
                    0.71435546875,
                    -1.0849609375,
                    2.626953125,
                    0.6474609375,
                    1.6611328125,
                    0.587890625,
                    0.2861328125,
                    -0.302978515625,
                    0.82080078125,
                    -0.78759765625,
                    -0.54541015625,
                    -1.48828125,
                    0.78076171875,
                    -0.402099609375,
                    1.4892578125,
                    -1.4697265625,
                    0.330322265625,
                    1.29296875,
                    -1.314453125,
                    0.473876953125,
                    -1.859375,
                    -0.5048828125,
                    -1.248046875,
                    0.335205078125,
                    0.11279296875,
                    -0.451416015625,
                    0.70458984375,
                    -0.57373046875,
                    -1.955078125,
                    1.0869140625,
                    -1.9150390625,
                    0.313720703125,
                    -2.51171875,
                    -0.560546875,
                    -0.94140625,
                    -0.118408203125,
                    -1.38671875,
                    1.3369140625,
                    1.7197265625,
                    -1.28125,
                    1.2265625,
                    -1.0966796875,
                    1.837890625,
                    2.294921875,
                    0.1597900390625,
                    -0.76611328125,
                    -1.98828125,
                    -1.0439453125,
                    -1.3564453125,
                    -0.6044921875,
                    1.142578125,
                    0.7705078125,
                    0.6806640625,
                    -1.0517578125,
                    -1.0810546875,
                    0.96484375,
                    -1.96484375,
                    -0.435302734375,
                    -1.376953125,
                    -0.5859375,
                    -1.7109375,
                    -0.771484375,
                    -0.5498046875,
                    0.66796875,
                    1.0830078125,
                    -0.439208984375,
                    -0.2396240234375,
                    -1.2548828125,
                    0.282958984375,
                    0.7978515625,
                    0.57373046875,
                    0.9423828125,
                    -0.487548828125,
                    -0.492919921875,
                    -0.08697509765625,
                    0.379638671875,
                    -0.8154296875,
                    0.51904296875,
                    -0.7451171875
                ],
                "intercept": -61.84375,
                "mean": -19341.14680403214
            },
            "m_canvas_draw_all_fisher_2": {
                "x": [
                    113,
                    214,
                    134,
                    174,
                    151,
                    63,
                    20,
                    35,
                    195,
                    106,
                    158,
                    102,
                    104,
                    120,
                    198,
                    79,
                    157,
                    150,
                    159,
                    115,
                    108,
                    204,
                    219,
                    104,
                    187,
                    141,
                    58,
                    109,
                    195,
                    193,
                    159,
                    103,
                    179,
                    105,
                    221,
                    23,
                    49,
                    41,
                    124,
                    159,
                    60,
                    216,
                    159,
                    106,
                    92,
                    82,
                    117,
                    41,
                    10,
                    14,
                    192,
                    153,
                    127,
                    155,
                    124,
                    104,
                    88
                ],
                "y": [
                    13,
                    98,
                    19,
                    66,
                    82,
                    182,
                    214,
                    10,
                    53,
                    95,
                    85,
                    12,
                    136,
                    93,
                    54,
                    91,
                    88,
                    92,
                    78,
                    15,
                    133,
                    41,
                    99,
                    132,
                    52,
                    13,
                    97,
                    98,
                    56,
                    49,
                    84,
                    134,
                    66,
                    139,
                    158,
                    94,
                    98,
                    14,
                    7,
                    17,
                    185,
                    99,
                    87,
                    136,
                    150,
                    91,
                    129,
                    194,
                    12,
                    236,
                    52,
                    17,
                    12,
                    93,
                    116,
                    11,
                    98
                ],
                "channel": [
                    2,
                    2,
                    2,
                    1,
                    1,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    1,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    0,
                    1,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2
                ],
                "coefs": [
                    2.169921875,
                    0.125244140625,
                    0.54150390625,
                    0.7275390625,
                    2.630859375,
                    2.125,
                    1.1005859375,
                    -4.48828125,
                    0.317626953125,
                    1.4775390625,
                    0.615234375,
                    1.958984375,
                    -0.533203125,
                    -1.1650390625,
                    1.13671875,
                    1.1943359375,
                    0.77734375,
                    -1.001953125,
                    0.288818359375,
                    -1.6318359375,
                    1.076171875,
                    -1.7734375,
                    0.6279296875,
                    1.13671875,
                    1.556640625,
                    2.822265625,
                    -1.5703125,
                    1.4521484375,
                    -0.9970703125,
                    -1.9931640625,
                    1.48828125,
                    0.5390625,
                    1.44140625,
                    -1.20703125,
                    1.5322265625,
                    -0.939453125,
                    -0.603515625,
                    1.78125,
                    -0.6552734375,
                    -1.7060546875,
                    1.0302734375,
                    -2.140625,
                    1.2080078125,
                    -0.51513671875,
                    0.42822265625,
                    1.5888671875,
                    0.93408203125,
                    0.8681640625,
                    0.3876953125,
                    -0.453369140625,
                    1.0712890625,
                    -0.62744140625,
                    -0.68115234375,
                    0.306396484375,
                    0.487548828125,
                    -0.74267578125,
                    -0.9052734375
                ],
                "intercept": 215.375,
                "mean": 2661.7948751751937
            },
            "m_canvas_draw_all_fisher_3": {
                "x": [
                    149,
                    20,
                    25,
                    119,
                    223,
                    211,
                    180,
                    153,
                    81,
                    229,
                    76,
                    199,
                    46,
                    108,
                    53,
                    108,
                    112,
                    18,
                    7,
                    214,
                    125,
                    17,
                    105,
                    165,
                    53,
                    210,
                    112,
                    153,
                    20,
                    196,
                    127,
                    66,
                    17,
                    206,
                    162,
                    17,
                    219,
                    188,
                    18,
                    117,
                    113,
                    54,
                    78,
                    34,
                    26,
                    27,
                    131,
                    151,
                    101,
                    21,
                    55,
                    12,
                    3,
                    206,
                    31,
                    13,
                    110,
                    23,
                    164,
                    68,
                    55,
                    113,
                    106,
                    176,
                    196,
                    106,
                    190,
                    187,
                    165,
                    221,
                    134,
                    82,
                    130,
                    154,
                    209,
                    129,
                    5,
                    109,
                    178,
                    188,
                    46,
                    123,
                    168,
                    177,
                    212,
                    125,
                    13,
                    44,
                    106,
                    95,
                    12,
                    35,
                    7,
                    91,
                    182,
                    16,
                    196,
                    50,
                    140,
                    0,
                    6,
                    21,
                    198,
                    89,
                    236,
                    58,
                    216,
                    107,
                    37,
                    111,
                    115,
                    10,
                    64,
                    46,
                    211,
                    138,
                    189,
                    12,
                    209,
                    23,
                    124,
                    3,
                    138,
                    15,
                    12,
                    52,
                    94,
                    43,
                    138,
                    128,
                    10,
                    108,
                    87,
                    106,
                    5,
                    109,
                    184,
                    16,
                    103,
                    224,
                    109,
                    215,
                    5,
                    215,
                    203,
                    51,
                    1,
                    197,
                    125,
                    128,
                    67,
                    42,
                    5,
                    114,
                    200,
                    54,
                    129,
                    121,
                    9,
                    7,
                    54,
                    179,
                    244,
                    162,
                    74,
                    2,
                    67,
                    134,
                    221,
                    92,
                    109,
                    63,
                    16,
                    207,
                    196,
                    18,
                    22,
                    221,
                    8,
                    6,
                    167,
                    71,
                    163,
                    16,
                    198,
                    144,
                    91,
                    223,
                    48,
                    148,
                    139,
                    170,
                    219,
                    197,
                    42,
                    157,
                    4,
                    174,
                    105,
                    108,
                    183,
                    163,
                    118,
                    114,
                    124,
                    147,
                    25,
                    79,
                    198,
                    127,
                    20,
                    22,
                    195,
                    223,
                    117,
                    61,
                    6,
                    93,
                    117,
                    213,
                    131,
                    87,
                    24,
                    216,
                    140,
                    59,
                    9,
                    165,
                    23,
                    190,
                    103,
                    104,
                    52,
                    104,
                    50,
                    5,
                    110,
                    25,
                    218,
                    222,
                    1,
                    217,
                    180,
                    199,
                    26,
                    126,
                    195,
                    201,
                    135,
                    117,
                    173,
                    119,
                    130,
                    162,
                    195,
                    48,
                    58,
                    210,
                    151,
                    129,
                    237,
                    203,
                    197,
                    108,
                    16,
                    171,
                    114,
                    66,
                    111,
                    103,
                    109,
                    90,
                    11,
                    208,
                    197,
                    164,
                    116,
                    130,
                    176,
                    121,
                    121,
                    105,
                    132,
                    81,
                    212,
                    168,
                    148,
                    204,
                    109,
                    112,
                    231,
                    193,
                    124,
                    126,
                    130,
                    118,
                    208,
                    184,
                    180,
                    126
                ],
                "y": [
                    9,
                    88,
                    216,
                    90,
                    94,
                    36,
                    62,
                    19,
                    90,
                    99,
                    98,
                    47,
                    191,
                    99,
                    181,
                    133,
                    19,
                    221,
                    235,
                    90,
                    15,
                    225,
                    136,
                    77,
                    93,
                    101,
                    96,
                    12,
                    4,
                    48,
                    119,
                    185,
                    221,
                    32,
                    78,
                    220,
                    97,
                    144,
                    222,
                    129,
                    89,
                    94,
                    95,
                    213,
                    9,
                    217,
                    113,
                    17,
                    20,
                    224,
                    91,
                    234,
                    97,
                    93,
                    214,
                    102,
                    132,
                    218,
                    14,
                    181,
                    95,
                    8,
                    95,
                    65,
                    45,
                    89,
                    99,
                    55,
                    78,
                    99,
                    10,
                    98,
                    18,
                    95,
                    92,
                    117,
                    234,
                    133,
                    60,
                    47,
                    90,
                    113,
                    70,
                    56,
                    32,
                    110,
                    228,
                    194,
                    132,
                    97,
                    228,
                    13,
                    238,
                    146,
                    97,
                    220,
                    51,
                    196,
                    16,
                    238,
                    235,
                    93,
                    49,
                    94,
                    99,
                    92,
                    96,
                    134,
                    206,
                    134,
                    130,
                    240,
                    186,
                    13,
                    31,
                    102,
                    99,
                    239,
                    32,
                    218,
                    118,
                    234,
                    12,
                    97,
                    238,
                    98,
                    155,
                    4,
                    91,
                    13,
                    12,
                    113,
                    91,
                    135,
                    237,
                    11,
                    61,
                    221,
                    14,
                    15,
                    98,
                    100,
                    236,
                    101,
                    35,
                    93,
                    238,
                    44,
                    115,
                    11,
                    176,
                    194,
                    239,
                    95,
                    43,
                    185,
                    114,
                    120,
                    229,
                    239,
                    93,
                    62,
                    93,
                    75,
                    91,
                    240,
                    99,
                    6,
                    87,
                    152,
                    18,
                    186,
                    221,
                    94,
                    52,
                    221,
                    218,
                    160,
                    238,
                    236,
                    77,
                    93,
                    11,
                    102,
                    44,
                    18,
                    147,
                    99,
                    100,
                    99,
                    102,
                    67,
                    98,
                    48,
                    5,
                    12,
                    234,
                    71,
                    92,
                    132,
                    64,
                    86,
                    116,
                    88,
                    119,
                    92,
                    216,
                    98,
                    50,
                    0,
                    221,
                    224,
                    42,
                    101,
                    90,
                    175,
                    234,
                    156,
                    20,
                    34,
                    111,
                    88,
                    99,
                    29,
                    100,
                    94,
                    237,
                    80,
                    215,
                    99,
                    99,
                    89,
                    92,
                    130,
                    90,
                    240,
                    137,
                    215,
                    101,
                    98,
                    232,
                    18,
                    62,
                    95,
                    215,
                    116,
                    44,
                    47,
                    17,
                    97,
                    59,
                    98,
                    6,
                    11,
                    52,
                    196,
                    183,
                    36,
                    95,
                    11,
                    99,
                    44,
                    48,
                    134,
                    94,
                    93,
                    97,
                    183,
                    17,
                    8,
                    8,
                    150,
                    232,
                    100,
                    49,
                    18,
                    90,
                    7,
                    57,
                    94,
                    90,
                    10,
                    110,
                    94,
                    33,
                    99,
                    7,
                    34,
                    132,
                    9,
                    96,
                    55,
                    113,
                    117,
                    118,
                    18,
                    34,
                    99,
                    57,
                    117
                ],
                "channel": [
                    2,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    1,
                    2,
                    1,
                    0,
                    0,
                    2,
                    0,
                    0,
                    1,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    2,
                    0,
                    1,
                    0,
                    0,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    1,
                    0,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    2,
                    2,
                    1,
                    2,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    1,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    1,
                    1,
                    2,
                    0,
                    2,
                    1,
                    0,
                    1,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    2,
                    1,
                    0,
                    2,
                    1,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    2,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    2,
                    1,
                    1,
                    0,
                    1,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    1,
                    1,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    0,
                    1,
                    2,
                    0,
                    0,
                    1,
                    1,
                    1,
                    0,
                    0,
                    0,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    1,
                    1,
                    2,
                    2,
                    0,
                    1,
                    2,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    1,
                    2,
                    0,
                    1,
                    2,
                    1,
                    2,
                    0,
                    2
                ],
                "coefs": [
                    -0.204833984375,
                    -0.2705078125,
                    -0.1048583984375,
                    -0.67431640625,
                    -1.248046875,
                    -0.298095703125,
                    -0.81787109375,
                    0.3408203125,
                    -0.87646484375,
                    -0.2425537109375,
                    0.427978515625,
                    0.78955078125,
                    0.286376953125,
                    -0.0098114013671875,
                    0.14697265625,
                    0.410400390625,
                    0.07586669921875,
                    -0.104736328125,
                    0.00969696044921875,
                    0.405517578125,
                    0.287353515625,
                    0.2264404296875,
                    -0.68359375,
                    0.82666015625,
                    0.354736328125,
                    -0.165771484375,
                    -0.8564453125,
                    -0.273193359375,
                    0.015838623046875,
                    -0.1783447265625,
                    0.08929443359375,
                    0.01073455810546875,
                    0.492431640625,
                    -0.89794921875,
                    0.10650634765625,
                    -0.488525390625,
                    -0.15185546875,
                    0.368896484375,
                    0.56591796875,
                    -0.9892578125,
                    0.5244140625,
                    -0.62109375,
                    0.6533203125,
                    -0.57421875,
                    1.080078125,
                    -0.5439453125,
                    -0.29833984375,
                    0.28759765625,
                    -0.572265625,
                    6.1015625,
                    0.73583984375,
                    0.005962371826171875,
                    -0.11260986328125,
                    0.34228515625,
                    1.3544921875,
                    0.06854248046875,
                    -0.18603515625,
                    1.541015625,
                    -0.0989990234375,
                    0.31005859375,
                    -0.36083984375,
                    -0.34619140625,
                    1.673828125,
                    0.477783203125,
                    -0.167724609375,
                    -0.164306640625,
                    0.49267578125,
                    0.058990478515625,
                    -0.2144775390625,
                    -0.307373046875,
                    0.0430908203125,
                    -0.76708984375,
                    0.25927734375,
                    0.1375732421875,
                    0.32080078125,
                    0.6591796875,
                    -0.122314453125,
                    -0.40576171875,
                    -0.7734375,
                    0.724609375,
                    -0.98779296875,
                    0.1099853515625,
                    0.75634765625,
                    0.79833984375,
                    -0.4052734375,
                    0.08404541015625,
                    0.66162109375,
                    0.09527587890625,
                    -0.65234375,
                    0.30615234375,
                    -0.046630859375,
                    0.49951171875,
                    0.0650634765625,
                    0.92431640625,
                    0.41748046875,
                    1.15625,
                    -0.0216064453125,
                    1.822265625,
                    0.307373046875,
                    -0.25732421875,
                    -0.09967041015625,
                    -1.1689453125,
                    0.39111328125,
                    0.309814453125,
                    0.1929931640625,
                    -0.2142333984375,
                    -0.2171630859375,
                    0.76318359375,
                    0.7646484375,
                    0.54541015625,
                    -0.10711669921875,
                    -0.31396484375,
                    -1.1884765625,
                    0.67724609375,
                    -0.031890869140625,
                    -0.57470703125,
                    0.358154296875,
                    0.2491455078125,
                    0.041900634765625,
                    0.951171875,
                    0.54150390625,
                    0.193115234375,
                    0.34326171875,
                    -1.0126953125,
                    0.221923828125,
                    -0.84130859375,
                    0.264892578125,
                    -0.202880859375,
                    0.68310546875,
                    0.10125732421875,
                    0.108642578125,
                    -0.350830078125,
                    -0.99609375,
                    -0.0771484375,
                    -0.356689453125,
                    0.64990234375,
                    0.1064453125,
                    0.1649169921875,
                    0.483154296875,
                    -0.059356689453125,
                    -1.0751953125,
                    1.966796875,
                    1.568359375,
                    1.0126953125,
                    -0.1219482421875,
                    -0.46826171875,
                    -0.031707763671875,
                    -0.27978515625,
                    0.367919921875,
                    0.53857421875,
                    1.533203125,
                    -0.0333251953125,
                    -0.3291015625,
                    0.047149658203125,
                    0.024627685546875,
                    -0.281494140625,
                    0.470458984375,
                    0.285888671875,
                    -0.280029296875,
                    -0.30126953125,
                    -0.4765625,
                    0.28515625,
                    0.2479248046875,
                    0.79833984375,
                    -0.04534912109375,
                    0.40185546875,
                    1.158203125,
                    -1.2099609375,
                    -0.74658203125,
                    0.64111328125,
                    -0.2568359375,
                    0.37255859375,
                    -0.67578125,
                    0.86572265625,
                    0.34130859375,
                    0.54931640625,
                    -0.35595703125,
                    0.54248046875,
                    0.132568359375,
                    -0.17041015625,
                    0.08660888671875,
                    0.275634765625,
                    -0.2362060546875,
                    0.1810302734375,
                    -0.28271484375,
                    -0.2100830078125,
                    -0.06634521484375,
                    -0.51953125,
                    1.33984375,
                    0.37841796875,
                    0.59326171875,
                    -0.8623046875,
                    -0.79052734375,
                    -0.83740234375,
                    -0.2088623046875,
                    -0.445068359375,
                    0.2069091796875,
                    -0.463134765625,
                    0.71435546875,
                    0.488525390625,
                    -1.140625,
                    -0.373046875,
                    -0.3291015625,
                    -1.0712890625,
                    0.28466796875,
                    0.005413055419921875,
                    1.4189453125,
                    -0.7626953125,
                    0.2330322265625,
                    -0.1033935546875,
                    2.197265625,
                    -2.390625,
                    0.9443359375,
                    0.59521484375,
                    -0.150146484375,
                    0.15576171875,
                    0.6767578125,
                    0.22216796875,
                    -0.1510009765625,
                    -0.225830078125,
                    0.60986328125,
                    0.50732421875,
                    0.13916015625,
                    0.065185546875,
                    0.0080413818359375,
                    -0.184326171875,
                    0.36572265625,
                    -0.235595703125,
                    0.1298828125,
                    0.81640625,
                    -0.8525390625,
                    1.666015625,
                    -0.4873046875,
                    0.46630859375,
                    0.54736328125,
                    -0.26220703125,
                    -0.34326171875,
                    -0.260498046875,
                    -0.69873046875,
                    0.424072265625,
                    0.69287109375,
                    -0.399658203125,
                    0.460693359375,
                    0.2091064453125,
                    -0.2222900390625,
                    0.283203125,
                    1.17578125,
                    0.280029296875,
                    0.3486328125,
                    1.05078125,
                    0.3173828125,
                    -0.02764892578125,
                    -0.296142578125,
                    -0.12384033203125,
                    0.2197265625,
                    -1.474609375,
                    -0.026397705078125,
                    0.08892822265625,
                    -0.2998046875,
                    0.310546875,
                    0.445556640625,
                    0.4814453125,
                    -1.078125,
                    -0.281982421875,
                    0.0300445556640625,
                    -0.60595703125,
                    0.497314453125,
                    -0.486083984375,
                    0.31103515625,
                    -0.276123046875,
                    -0.232177734375,
                    -0.310791015625,
                    0.71435546875,
                    -0.728515625,
                    -0.470947265625,
                    0.056610107421875,
                    0.68994140625,
                    0.2998046875,
                    0.42919921875,
                    -0.7373046875,
                    0.58154296875,
                    -0.587890625,
                    0.267333984375,
                    -0.36279296875,
                    0.333740234375,
                    0.2587890625,
                    0.779296875,
                    0.282470703125,
                    0.197998046875,
                    -0.29638671875,
                    0.332275390625,
                    -0.1536865234375,
                    -0.395263671875,
                    -0.50244140625,
                    0.4453125,
                    0.223876953125,
                    0.472412109375,
                    0.2308349609375,
                    -0.324951171875,
                    0.22314453125
                ],
                "intercept": -6.25,
                "mean": 1077.6220696733121
            },
            "m_canvas_draw_all_fisher_6": {
                "x": [
                    124,
                    174,
                    116,
                    161,
                    158,
                    23,
                    213,
                    133,
                    29,
                    91,
                    90,
                    199,
                    212,
                    135,
                    131,
                    52,
                    50,
                    160,
                    198,
                    162,
                    193,
                    242,
                    230,
                    27,
                    196,
                    149,
                    51,
                    96,
                    201,
                    31,
                    221,
                    46,
                    93,
                    5,
                    19,
                    109,
                    94,
                    197,
                    129,
                    128,
                    133,
                    180,
                    114,
                    29,
                    36,
                    57,
                    237,
                    126,
                    11,
                    125,
                    20,
                    27,
                    110,
                    140,
                    105,
                    128,
                    200,
                    57,
                    26,
                    26,
                    117,
                    110,
                    16,
                    7,
                    179,
                    10,
                    18,
                    124,
                    108,
                    116,
                    128,
                    2,
                    48,
                    160,
                    23,
                    162,
                    121,
                    176,
                    158,
                    85,
                    134,
                    213,
                    20,
                    175,
                    110,
                    12,
                    115,
                    193,
                    94,
                    170,
                    116,
                    25,
                    39,
                    131,
                    187,
                    32,
                    56,
                    55,
                    111,
                    8,
                    111,
                    200,
                    103,
                    24,
                    52,
                    41,
                    7,
                    15,
                    131,
                    151,
                    197,
                    4,
                    56,
                    129,
                    135,
                    164,
                    240,
                    24,
                    25,
                    108,
                    165,
                    89,
                    125,
                    124,
                    93,
                    112,
                    182,
                    105,
                    241,
                    176,
                    24,
                    8,
                    107,
                    146,
                    211,
                    167,
                    133,
                    19,
                    112,
                    48,
                    127,
                    7,
                    59,
                    189,
                    204,
                    55,
                    0,
                    15,
                    93,
                    193,
                    143,
                    18,
                    53,
                    16,
                    195,
                    74,
                    82,
                    24,
                    55,
                    96,
                    127,
                    211,
                    0,
                    23,
                    224,
                    13,
                    172,
                    121,
                    106,
                    135,
                    113,
                    24,
                    13,
                    20,
                    193,
                    39,
                    84,
                    166,
                    10,
                    14,
                    25,
                    23,
                    162,
                    194,
                    3,
                    94,
                    60,
                    10,
                    41,
                    225,
                    117,
                    1,
                    213,
                    155,
                    195,
                    179,
                    201,
                    153,
                    54,
                    208,
                    130,
                    42,
                    1,
                    175,
                    212,
                    184,
                    6,
                    60,
                    117,
                    22,
                    197,
                    111,
                    151,
                    160,
                    54,
                    173,
                    10,
                    8,
                    19
                ],
                "y": [
                    108,
                    68,
                    100,
                    80,
                    81,
                    217,
                    91,
                    12,
                    214,
                    146,
                    150,
                    48,
                    34,
                    19,
                    17,
                    89,
                    185,
                    81,
                    49,
                    78,
                    54,
                    90,
                    97,
                    220,
                    41,
                    84,
                    95,
                    148,
                    45,
                    219,
                    101,
                    195,
                    142,
                    236,
                    218,
                    99,
                    148,
                    50,
                    13,
                    117,
                    6,
                    63,
                    93,
                    218,
                    199,
                    93,
                    96,
                    3,
                    236,
                    112,
                    217,
                    214,
                    132,
                    90,
                    130,
                    17,
                    43,
                    92,
                    216,
                    218,
                    93,
                    129,
                    102,
                    237,
                    69,
                    233,
                    224,
                    4,
                    132,
                    131,
                    13,
                    235,
                    198,
                    75,
                    92,
                    81,
                    113,
                    60,
                    83,
                    92,
                    113,
                    98,
                    219,
                    65,
                    96,
                    234,
                    95,
                    42,
                    154,
                    69,
                    135,
                    221,
                    199,
                    115,
                    56,
                    205,
                    179,
                    92,
                    101,
                    233,
                    95,
                    48,
                    18,
                    216,
                    92,
                    198,
                    238,
                    221,
                    12,
                    84,
                    46,
                    236,
                    95,
                    17,
                    15,
                    74,
                    98,
                    94,
                    213,
                    135,
                    73,
                    154,
                    118,
                    5,
                    156,
                    95,
                    67,
                    133,
                    94,
                    66,
                    101,
                    231,
                    135,
                    97,
                    36,
                    75,
                    107,
                    224,
                    92,
                    98,
                    2,
                    239,
                    175,
                    47,
                    48,
                    100,
                    239,
                    222,
                    151,
                    45,
                    92,
                    223,
                    98,
                    222,
                    49,
                    163,
                    97,
                    97,
                    90,
                    153,
                    9,
                    95,
                    241,
                    220,
                    98,
                    238,
                    65,
                    99,
                    132,
                    117,
                    136,
                    220,
                    99,
                    220,
                    44,
                    200,
                    149,
                    72,
                    234,
                    237,
                    216,
                    213,
                    73,
                    54,
                    243,
                    142,
                    176,
                    236,
                    198,
                    99,
                    89,
                    235,
                    94,
                    80,
                    39,
                    64,
                    48,
                    94,
                    179,
                    32,
                    13,
                    194,
                    240,
                    67,
                    94,
                    68,
                    237,
                    177,
                    130,
                    217,
                    45,
                    93,
                    96,
                    82,
                    97,
                    69,
                    237,
                    235,
                    101
                ],
                "channel": [
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    1,
                    0,
                    1,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    1,
                    0,
                    1,
                    1,
                    2,
                    2,
                    0,
                    0,
                    2,
                    1,
                    2,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    1,
                    2,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    2,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    1,
                    2,
                    1,
                    2,
                    1,
                    2
                ],
                "coefs": [
                    -2.421875,
                    0.08642578125,
                    1.921875,
                    -1.1533203125,
                    -2.69140625,
                    -0.810546875,
                    -1.556640625,
                    -2.275390625,
                    0.654296875,
                    -0.347900390625,
                    -2.134765625,
                    -0.76904296875,
                    0.57275390625,
                    -0.626953125,
                    -1.1337890625,
                    1.447265625,
                    -0.296875,
                    -2.134765625,
                    -1.5849609375,
                    -0.47705078125,
                    -0.486083984375,
                    -1.1875,
                    -0.62548828125,
                    -0.833984375,
                    -0.1944580078125,
                    1.716796875,
                    2.03515625,
                    -0.86376953125,
                    -0.849609375,
                    -1.3603515625,
                    -0.10186767578125,
                    -1.509765625,
                    -0.66552734375,
                    -0.203125,
                    -0.6064453125,
                    -0.97265625,
                    -0.1624755859375,
                    -0.84375,
                    0.477783203125,
                    -1.2177734375,
                    -1.0244140625,
                    -1.298828125,
                    -2.0390625,
                    0.04534912109375,
                    -1.173828125,
                    0.79296875,
                    -0.998046875,
                    -1.4638671875,
                    -0.08203125,
                    -0.38671875,
                    -0.65966796875,
                    -0.5166015625,
                    -1.4345703125,
                    -2.76953125,
                    -0.295654296875,
                    0.7822265625,
                    -0.95654296875,
                    -2.349609375,
                    -1.2685546875,
                    -1.5419921875,
                    -0.7060546875,
                    -1.9541015625,
                    -0.1497802734375,
                    0.33251953125,
                    -0.84619140625,
                    0.2020263671875,
                    0.0135955810546875,
                    -0.1812744140625,
                    -0.1256103515625,
                    -0.06658935546875,
                    1.2353515625,
                    -0.03240966796875,
                    -1.1640625,
                    -1.2138671875,
                    -1.3603515625,
                    -0.76513671875,
                    -3.494140625,
                    0.7900390625,
                    -1.001953125,
                    3.728515625,
                    -2.763671875,
                    0.461181640625,
                    -0.2325439453125,
                    1.5556640625,
                    -2.0390625,
                    0.274169921875,
                    -1.005859375,
                    -0.115966796875,
                    -0.388916015625,
                    0.591796875,
                    -1.69921875,
                    0.177978515625,
                    -0.1124267578125,
                    -0.5390625,
                    0.71142578125,
                    -1.6669921875,
                    -3.03125,
                    -1.3916015625,
                    -1.337890625,
                    0.69091796875,
                    0.9365234375,
                    -0.75048828125,
                    0.0091094970703125,
                    -0.50048828125,
                    -2.83984375,
                    -1.3466796875,
                    -0.043304443359375,
                    -0.474609375,
                    2.154296875,
                    -1.189453125,
                    0.0062713623046875,
                    -0.367431640625,
                    0.65087890625,
                    0.79150390625,
                    0.44384765625,
                    -1.09375,
                    -0.466552734375,
                    0.12066650390625,
                    -1.935546875,
                    -0.395751953125,
                    -0.04034423828125,
                    -1.92578125,
                    -2.8203125,
                    0.1273193359375,
                    -2.1875,
                    -1.94140625,
                    -0.10528564453125,
                    1.6728515625,
                    -0.58056640625,
                    -1.0791015625,
                    -2.94140625,
                    0.53759765625,
                    -1.2744140625,
                    -0.463134765625,
                    0.18017578125,
                    0.3974609375,
                    1.0625,
                    -0.693359375,
                    -0.35302734375,
                    2.087890625,
                    -2.75,
                    0.69970703125,
                    0.939453125,
                    -1.013671875,
                    -1.6826171875,
                    -2.810546875,
                    0.10455322265625,
                    0.22998046875,
                    -0.96240234375,
                    1.072265625,
                    -1.17578125,
                    0.226318359375,
                    -1.689453125,
                    0.5947265625,
                    0.48291015625,
                    0.72119140625,
                    -1.5693359375,
                    0.61962890625,
                    2.48046875,
                    -1.1044921875,
                    0.221435546875,
                    -0.396728515625,
                    -0.003936767578125,
                    -0.861328125,
                    -1.0107421875,
                    -1.2216796875,
                    0.7861328125,
                    0.2890625,
                    -1.0810546875,
                    -5.55859375,
                    0.9482421875,
                    -0.78369140625,
                    0.1480712890625,
                    -0.07891845703125,
                    -0.5625,
                    -0.1029052734375,
                    -2.240234375,
                    -1.0341796875,
                    -1.0322265625,
                    0.406982421875,
                    1.9091796875,
                    0.90185546875,
                    -0.55517578125,
                    -1.1376953125,
                    0.378173828125,
                    0.369140625,
                    -0.93408203125,
                    0.3017578125,
                    -2.828125,
                    0.6884765625,
                    1.111328125,
                    -0.93212890625,
                    0.65625,
                    -1.423828125,
                    -0.84716796875,
                    1.0087890625,
                    -0.25048828125,
                    -0.1578369140625,
                    1.3857421875,
                    0.380126953125,
                    -0.1937255859375,
                    -0.351806640625,
                    -0.1602783203125,
                    0.67822265625,
                    -0.1575927734375,
                    -1.2451171875,
                    -1.095703125,
                    -1.037109375,
                    0.50341796875,
                    -0.6669921875,
                    0.80810546875,
                    1.2412109375,
                    0.323486328125,
                    -0.76025390625,
                    0.69189453125,
                    0.76708984375,
                    0.65380859375,
                    -0.58935546875,
                    -0.54296875
                ],
                "intercept": -123,
                "mean": -14959.691020196451
            },
            "m_canvas_draw_all_fisher_7": {
                "x": [
                    206,
                    159,
                    107,
                    214,
                    133,
                    88,
                    167,
                    198,
                    140,
                    77,
                    225,
                    84,
                    110,
                    118,
                    192,
                    11,
                    124,
                    19,
                    129,
                    135,
                    192,
                    8,
                    230,
                    9,
                    121,
                    97,
                    115,
                    198,
                    18,
                    193,
                    121,
                    20,
                    115,
                    47,
                    111,
                    229,
                    111,
                    27,
                    89,
                    211,
                    19,
                    85,
                    218,
                    196,
                    141,
                    133,
                    39,
                    240,
                    117,
                    57,
                    195,
                    134,
                    46,
                    210,
                    86,
                    183,
                    115,
                    26,
                    177,
                    27,
                    110,
                    94,
                    176,
                    60,
                    127,
                    216,
                    234,
                    18,
                    41,
                    159,
                    149,
                    154,
                    199,
                    115,
                    210,
                    91,
                    200,
                    17,
                    107,
                    103,
                    173,
                    218,
                    18,
                    129,
                    105,
                    93,
                    1,
                    31,
                    58,
                    92,
                    196,
                    236,
                    11,
                    193,
                    186,
                    228,
                    7,
                    110,
                    173,
                    212,
                    89,
                    94,
                    200,
                    33,
                    161,
                    50,
                    44,
                    66,
                    225,
                    160,
                    12,
                    188,
                    55,
                    222,
                    79,
                    211,
                    76,
                    39,
                    189,
                    216,
                    21,
                    105,
                    46,
                    18,
                    241,
                    192,
                    126,
                    9,
                    75,
                    198,
                    151,
                    104,
                    164,
                    86,
                    10,
                    201,
                    198,
                    4,
                    23,
                    25,
                    201,
                    110,
                    221,
                    149,
                    10,
                    185,
                    124,
                    98,
                    140,
                    51,
                    19,
                    38,
                    87,
                    83,
                    56,
                    17,
                    199,
                    118,
                    85,
                    18,
                    219,
                    121,
                    103,
                    160,
                    199,
                    178,
                    105,
                    229,
                    86,
                    107,
                    226,
                    17,
                    94,
                    147,
                    213,
                    108,
                    225,
                    238,
                    195,
                    91,
                    206,
                    3,
                    164,
                    190,
                    235,
                    105,
                    190
                ],
                "y": [
                    40,
                    78,
                    6,
                    99,
                    7,
                    154,
                    68,
                    43,
                    20,
                    169,
                    100,
                    88,
                    141,
                    119,
                    53,
                    235,
                    118,
                    219,
                    7,
                    0,
                    45,
                    237,
                    93,
                    229,
                    98,
                    3,
                    130,
                    44,
                    218,
                    58,
                    120,
                    13,
                    98,
                    98,
                    9,
                    95,
                    98,
                    213,
                    149,
                    91,
                    213,
                    156,
                    90,
                    45,
                    101,
                    118,
                    200,
                    97,
                    129,
                    95,
                    47,
                    18,
                    98,
                    37,
                    144,
                    58,
                    99,
                    216,
                    72,
                    93,
                    17,
                    144,
                    66,
                    174,
                    119,
                    97,
                    98,
                    214,
                    17,
                    85,
                    85,
                    18,
                    50,
                    15,
                    31,
                    153,
                    47,
                    218,
                    95,
                    92,
                    99,
                    94,
                    227,
                    113,
                    136,
                    151,
                    240,
                    215,
                    92,
                    145,
                    53,
                    99,
                    241,
                    42,
                    55,
                    89,
                    15,
                    130,
                    59,
                    92,
                    156,
                    147,
                    51,
                    10,
                    15,
                    98,
                    5,
                    177,
                    26,
                    83,
                    239,
                    54,
                    90,
                    97,
                    95,
                    27,
                    94,
                    11,
                    47,
                    94,
                    222,
                    135,
                    199,
                    212,
                    99,
                    49,
                    4,
                    230,
                    165,
                    49,
                    95,
                    136,
                    12,
                    151,
                    4,
                    45,
                    41,
                    239,
                    217,
                    222,
                    38,
                    98,
                    93,
                    18,
                    234,
                    97,
                    120,
                    147,
                    13,
                    88,
                    217,
                    202,
                    156,
                    152,
                    91,
                    220,
                    39,
                    93,
                    93,
                    223,
                    93,
                    114,
                    133,
                    80,
                    47,
                    58,
                    20,
                    95,
                    97,
                    8,
                    99,
                    219,
                    142,
                    19,
                    96,
                    98,
                    95,
                    92,
                    50,
                    157,
                    37,
                    242,
                    16,
                    50,
                    96,
                    14,
                    42
                ],
                "channel": [
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    2,
                    1,
                    0,
                    0,
                    1,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    0,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    1,
                    1,
                    0,
                    2,
                    1,
                    1,
                    2,
                    2,
                    2,
                    1,
                    0,
                    2,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    1,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    2,
                    1,
                    2,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    1,
                    2,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0
                ],
                "coefs": [
                    -0.3515625,
                    0.42919921875,
                    -0.299560546875,
                    -1.240234375,
                    -0.3896484375,
                    0.50732421875,
                    0.445068359375,
                    -0.473876953125,
                    0.2406005859375,
                    -0.44970703125,
                    1.1552734375,
                    -0.85009765625,
                    0.650390625,
                    -0.05029296875,
                    -0.095703125,
                    -0.0164337158203125,
                    -0.1563720703125,
                    0.0253448486328125,
                    -0.264892578125,
                    0.27294921875,
                    -0.482666015625,
                    0.05169677734375,
                    -0.62255859375,
                    0.369873046875,
                    0.423583984375,
                    -0.0221710205078125,
                    -0.463134765625,
                    0.306396484375,
                    0.1866455078125,
                    -0.796875,
                    -0.677734375,
                    -0.93408203125,
                    0.134033203125,
                    -0.043670654296875,
                    0.3427734375,
                    -0.470458984375,
                    0.86181640625,
                    -0.15771484375,
                    -1.0361328125,
                    -0.1773681640625,
                    -0.6572265625,
                    -1.177734375,
                    0.83740234375,
                    0.0826416015625,
                    -0.8232421875,
                    -0.2066650390625,
                    -0.09332275390625,
                    -1.6552734375,
                    -0.88525390625,
                    -0.051025390625,
                    -0.26171875,
                    0.309326171875,
                    -0.437255859375,
                    0.935546875,
                    -2.5,
                    -0.039459228515625,
                    -0.79833984375,
                    -0.8154296875,
                    0.71435546875,
                    -0.6845703125,
                    0.034423828125,
                    -0.79736328125,
                    -0.21484375,
                    0.28076171875,
                    -0.388671875,
                    -0.52685546875,
                    0.76123046875,
                    -1.1220703125,
                    0.52685546875,
                    -0.005603790283203125,
                    -0.6484375,
                    0.5458984375,
                    -0.005096435546875,
                    -0.75634765625,
                    -0.1883544921875,
                    -0.3720703125,
                    -0.39013671875,
                    -0.89306640625,
                    -1.2548828125,
                    0.97802734375,
                    -0.83740234375,
                    -0.8134765625,
                    -0.11834716796875,
                    0.3193359375,
                    0.273681640625,
                    -0.148193359375,
                    0.1260986328125,
                    0.59326171875,
                    -0.424072265625,
                    -0.1268310546875,
                    -0.7353515625,
                    0.91552734375,
                    0.28125,
                    -1.251953125,
                    0.6953125,
                    -0.65576171875,
                    -0.1343994140625,
                    -0.5478515625,
                    -1.0048828125,
                    -1.5634765625,
                    -0.994140625,
                    0.3115234375,
                    -0.424560546875,
                    -0.69775390625,
                    0.41943359375,
                    -1.0908203125,
                    0.385986328125,
                    -1.087890625,
                    -1.5224609375,
                    -0.1353759765625,
                    0.28466796875,
                    0.59375,
                    -0.7314453125,
                    1.0966796875,
                    0.7861328125,
                    -0.173828125,
                    -0.466064453125,
                    0.60400390625,
                    -1.0595703125,
                    -0.7333984375,
                    0.1368408203125,
                    -0.76708984375,
                    -0.2454833984375,
                    -0.2177734375,
                    0.06292724609375,
                    0.69482421875,
                    -0.66162109375,
                    -0.492919921875,
                    0.494384765625,
                    -0.34228515625,
                    0.00354766845703125,
                    -0.35302734375,
                    -0.0127410888671875,
                    -1.162109375,
                    0.2330322265625,
                    0.6044921875,
                    -0.6455078125,
                    0.54443359375,
                    -0.3916015625,
                    -0.36572265625,
                    0.37255859375,
                    -0.273193359375,
                    -0.79150390625,
                    0.296142578125,
                    0.95263671875,
                    0.15185546875,
                    -0.62744140625,
                    0.306396484375,
                    0.5419921875,
                    -0.59375,
                    -0.1729736328125,
                    0.2489013671875,
                    -1.02734375,
                    1.078125,
                    -0.277587890625,
                    0.308837890625,
                    0.84619140625,
                    0.35888671875,
                    0.689453125,
                    -0.25439453125,
                    0.7587890625,
                    -0.447021484375,
                    0.318603515625,
                    0.310546875,
                    0.35009765625,
                    -0.2880859375,
                    0.201171875,
                    0.78125,
                    -0.55224609375,
                    0.5087890625,
                    -0.60009765625,
                    -0.26318359375,
                    -0.1671142578125,
                    0.1356201171875,
                    0.4326171875,
                    0.2408447265625,
                    -0.54296875,
                    0.56884765625,
                    -0.237060546875,
                    -0.544921875,
                    -0.184326171875,
                    -0.08331298828125,
                    0.135986328125,
                    0.32421875,
                    -0.481201171875,
                    -0.2120361328125,
                    0.26025390625
                ],
                "intercept": -26.6875,
                "mean": -1459.5537438716299
            }
        },
        "m_canvas_emojis": {
            "m_canvas_emojis_fisher_12": {
                "x": [
                    2,
                    94,
                    83,
                    26,
                    11,
                    68,
                    26,
                    43,
                    27,
                    48,
                    56,
                    9,
                    90,
                    82,
                    93,
                    17,
                    73,
                    24,
                    58,
                    12,
                    99,
                    19,
                    11,
                    98,
                    47,
                    73,
                    53,
                    96,
                    70,
                    64,
                    77,
                    67,
                    96,
                    39,
                    8,
                    98,
                    94,
                    64,
                    52,
                    23,
                    30,
                    51,
                    95,
                    15,
                    30,
                    55,
                    98,
                    81,
                    90,
                    67,
                    15,
                    14,
                    76,
                    69,
                    82,
                    62,
                    5,
                    23,
                    31,
                    26,
                    60,
                    77,
                    70,
                    37,
                    83,
                    42,
                    29,
                    47,
                    62,
                    54,
                    82,
                    72,
                    83,
                    63,
                    23,
                    46,
                    0,
                    57,
                    82,
                    2,
                    93,
                    31,
                    99,
                    10,
                    95,
                    17,
                    42,
                    68,
                    84,
                    50,
                    89,
                    4,
                    95,
                    27,
                    21,
                    61,
                    14,
                    60,
                    97,
                    54,
                    45,
                    86,
                    53,
                    67,
                    35,
                    77,
                    15,
                    32,
                    24,
                    82,
                    19,
                    71,
                    95,
                    24,
                    88,
                    17,
                    18,
                    1,
                    6,
                    93,
                    82,
                    10,
                    46,
                    28,
                    28,
                    37,
                    29,
                    68,
                    83,
                    22,
                    21,
                    56,
                    68,
                    62,
                    44,
                    38,
                    47,
                    87,
                    22,
                    97,
                    23,
                    77,
                    65,
                    77,
                    31,
                    68,
                    47,
                    53,
                    90,
                    60,
                    89,
                    27,
                    98,
                    62,
                    48,
                    67,
                    73,
                    25,
                    67,
                    23,
                    69,
                    99,
                    24,
                    27,
                    95,
                    88,
                    53,
                    77,
                    31,
                    54,
                    9,
                    49,
                    25,
                    17,
                    78,
                    67,
                    68,
                    98,
                    97,
                    87,
                    8,
                    17,
                    60,
                    30,
                    28,
                    97,
                    88,
                    26,
                    57,
                    81,
                    46,
                    44,
                    23,
                    18,
                    96,
                    83,
                    55,
                    22,
                    5,
                    21,
                    67,
                    29,
                    69,
                    3,
                    93,
                    95,
                    31,
                    30,
                    87,
                    17,
                    74,
                    8,
                    1,
                    81,
                    68,
                    49,
                    15,
                    77,
                    33,
                    41,
                    2,
                    3,
                    87,
                    78,
                    54,
                    15,
                    67,
                    24,
                    87,
                    54,
                    71,
                    46,
                    27,
                    79,
                    0,
                    36,
                    91,
                    50,
                    75,
                    68,
                    83,
                    25,
                    42,
                    19,
                    32,
                    99,
                    90,
                    15,
                    9,
                    54,
                    35,
                    10,
                    97,
                    97,
                    2,
                    47,
                    50,
                    50,
                    14,
                    24,
                    10
                ],
                "y": [
                    61,
                    7,
                    24,
                    92,
                    69,
                    35,
                    82,
                    57,
                    91,
                    52,
                    52,
                    66,
                    15,
                    33,
                    73,
                    86,
                    31,
                    87,
                    49,
                    73,
                    69,
                    90,
                    87,
                    16,
                    65,
                    27,
                    70,
                    5,
                    42,
                    68,
                    25,
                    47,
                    11,
                    61,
                    94,
                    71,
                    66,
                    40,
                    61,
                    89,
                    83,
                    58,
                    23,
                    69,
                    77,
                    57,
                    67,
                    23,
                    67,
                    44,
                    85,
                    92,
                    29,
                    29,
                    28,
                    60,
                    69,
                    85,
                    74,
                    78,
                    47,
                    33,
                    44,
                    62,
                    63,
                    65,
                    84,
                    71,
                    57,
                    67,
                    21,
                    34,
                    32,
                    41,
                    86,
                    61,
                    66,
                    51,
                    25,
                    67,
                    17,
                    77,
                    9,
                    60,
                    24,
                    88,
                    60,
                    65,
                    19,
                    71,
                    68,
                    98,
                    68,
                    83,
                    67,
                    45,
                    61,
                    37,
                    9,
                    60,
                    71,
                    15,
                    67,
                    37,
                    69,
                    38,
                    93,
                    68,
                    77,
                    22,
                    85,
                    48,
                    73,
                    83,
                    31,
                    87,
                    69,
                    67,
                    71,
                    64,
                    29,
                    59,
                    70,
                    72,
                    80,
                    77,
                    87,
                    35,
                    61,
                    65,
                    90,
                    47,
                    71,
                    66,
                    70,
                    70,
                    54,
                    32,
                    79,
                    20,
                    68,
                    18,
                    45,
                    34,
                    64,
                    45,
                    56,
                    64,
                    18,
                    42,
                    20,
                    78,
                    73,
                    71,
                    65,
                    46,
                    26,
                    85,
                    48,
                    96,
                    66,
                    2,
                    66,
                    79,
                    11,
                    21,
                    68,
                    71,
                    71,
                    64,
                    95,
                    61,
                    83,
                    89,
                    69,
                    39,
                    69,
                    12,
                    8,
                    23,
                    92,
                    93,
                    39,
                    75,
                    87,
                    67,
                    70,
                    72,
                    43,
                    31,
                    61,
                    64,
                    86,
                    86,
                    17,
                    67,
                    58,
                    78,
                    60,
                    65,
                    69,
                    83,
                    36,
                    72,
                    69,
                    71,
                    67,
                    72,
                    60,
                    88,
                    40,
                    99,
                    95,
                    65,
                    29,
                    54,
                    80,
                    23,
                    79,
                    64,
                    70,
                    65,
                    27,
                    35,
                    53,
                    69,
                    44,
                    76,
                    18,
                    61,
                    30,
                    60,
                    84,
                    38,
                    66,
                    83,
                    9,
                    56,
                    70,
                    66,
                    71,
                    85,
                    59,
                    88,
                    64,
                    5,
                    11,
                    68,
                    74,
                    65,
                    64,
                    93,
                    60,
                    73,
                    71,
                    58,
                    72,
                    60,
                    71,
                    89,
                    96
                ],
                "channel": [
                    2,
                    0,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    2,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    1,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    1,
                    2,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    1,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    1,
                    1,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    2,
                    1,
                    2,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                "coefs": [
                    0.10845947265625,
                    -0.4990234375,
                    0.53759765625,
                    -0.194091796875,
                    -0.42529296875,
                    -0.08624267578125,
                    0.35693359375,
                    0.256591796875,
                    0.386474609375,
                    -0.3857421875,
                    0.640625,
                    0.381103515625,
                    -0.29296875,
                    -0.1485595703125,
                    -0.327880859375,
                    -0.09613037109375,
                    -0.1502685546875,
                    0.06500244140625,
                    0.420166015625,
                    0.0301513671875,
                    -0.1822509765625,
                    -0.10552978515625,
                    0.262939453125,
                    0.253173828125,
                    -0.0217742919921875,
                    -0.200439453125,
                    -0.17822265625,
                    -0.1961669921875,
                    -0.209716796875,
                    -0.193359375,
                    0.32958984375,
                    -0.31494140625,
                    -0.7646484375,
                    0.127685546875,
                    0.063720703125,
                    -0.06793212890625,
                    -0.1357421875,
                    -0.0268402099609375,
                    -0.478515625,
                    -0.3212890625,
                    0.75390625,
                    0.060943603515625,
                    -0.3623046875,
                    -0.08563232421875,
                    0.2607421875,
                    0.194580078125,
                    -0.46044921875,
                    -0.139892578125,
                    -0.01244354248046875,
                    0.271728515625,
                    -0.3828125,
                    0.284423828125,
                    0.08184814453125,
                    -0.873046875,
                    -0.227783203125,
                    -1.0986328125,
                    -0.0830078125,
                    0.128662109375,
                    -0.32373046875,
                    0.055328369140625,
                    0.313720703125,
                    -0.5234375,
                    -0.238037109375,
                    0.10284423828125,
                    -0.433837890625,
                    -0.2105712890625,
                    0.1500244140625,
                    0.300537109375,
                    0.070556640625,
                    -0.007110595703125,
                    0.31787109375,
                    -0.396728515625,
                    -0.31103515625,
                    0.40625,
                    0.035369873046875,
                    0.1435546875,
                    -0.09576416015625,
                    0.20166015625,
                    -0.2012939453125,
                    -0.20068359375,
                    0.3095703125,
                    0.085693359375,
                    -0.166015625,
                    -0.1959228515625,
                    -0.027618408203125,
                    -0.14208984375,
                    -0.11212158203125,
                    -0.11572265625,
                    0.2447509765625,
                    0.1671142578125,
                    -0.18115234375,
                    0.36669921875,
                    -0.01947021484375,
                    0.58544921875,
                    0.00370025634765625,
                    -0.005283355712890625,
                    -0.458984375,
                    0.05328369140625,
                    -0.047515869140625,
                    -0.2340087890625,
                    -0.186279296875,
                    0.269775390625,
                    -0.1846923828125,
                    0.01433563232421875,
                    0.35888671875,
                    0.101318359375,
                    0.58984375,
                    -0.4326171875,
                    0.041900634765625,
                    -0.017486572265625,
                    -0.3408203125,
                    0.11651611328125,
                    -0.47216796875,
                    -0.066650390625,
                    0.0150299072265625,
                    -0.240966796875,
                    -0.25,
                    -0.428466796875,
                    -0.16845703125,
                    -0.353515625,
                    -0.1500244140625,
                    -0.65380859375,
                    -0.1298828125,
                    0.27734375,
                    0.056427001953125,
                    -0.208984375,
                    0.2252197265625,
                    -0.213623046875,
                    -0.52490234375,
                    -0.206298828125,
                    -0.2020263671875,
                    0.056243896484375,
                    -0.288330078125,
                    0.051910400390625,
                    -0.2059326171875,
                    -0.03326416015625,
                    -0.1962890625,
                    0.03515625,
                    0.134521484375,
                    0.0175323486328125,
                    0.0129852294921875,
                    0.04913330078125,
                    0.5400390625,
                    -0.265869140625,
                    -0.1744384765625,
                    0.056915283203125,
                    0.204345703125,
                    -0.119140625,
                    0.141357421875,
                    -0.1580810546875,
                    -0.1990966796875,
                    0.4189453125,
                    -0.011993408203125,
                    -0.27734375,
                    0.004695892333984375,
                    -0.02349853515625,
                    0.447021484375,
                    0.06390380859375,
                    0.11810302734375,
                    0.030609130859375,
                    -0.16845703125,
                    -0.10791015625,
                    0.0224761962890625,
                    0.0277557373046875,
                    0.1397705078125,
                    0.399169921875,
                    -0.20654296875,
                    -0.025115966796875,
                    -0.070068359375,
                    -0.335205078125,
                    0.07244873046875,
                    -0.10626220703125,
                    -0.381591796875,
                    -0.50048828125,
                    0.314208984375,
                    0.164794921875,
                    -0.73388671875,
                    -0.335205078125,
                    -0.395751953125,
                    0.100830078125,
                    0.2286376953125,
                    -0.25,
                    -0.281005859375,
                    0.400146484375,
                    0.228515625,
                    -0.2056884765625,
                    -0.058135986328125,
                    0.05975341796875,
                    0.461181640625,
                    -0.16357421875,
                    -0.256103515625,
                    0.2308349609375,
                    0.0261383056640625,
                    -0.2734375,
                    -0.276611328125,
                    -0.0921630859375,
                    0.266845703125,
                    0.252685546875,
                    -0.2178955078125,
                    -0.332275390625,
                    -0.240478515625,
                    0.1253662109375,
                    -0.08544921875,
                    -0.09783935546875,
                    -0.225830078125,
                    0.12103271484375,
                    -0.11846923828125,
                    -0.0872802734375,
                    -0.3427734375,
                    -0.206787109375,
                    -0.1468505859375,
                    0.1712646484375,
                    0.0257110595703125,
                    -0.08380126953125,
                    -0.0819091796875,
                    -0.18896484375,
                    0.028564453125,
                    0.10833740234375,
                    0.11492919921875,
                    -0.09478759765625,
                    -0.346923828125,
                    0.18115234375,
                    0.278564453125,
                    -0.10150146484375,
                    0.05914306640625,
                    -0.1536865234375,
                    0.10504150390625,
                    0.099609375,
                    -0.197998046875,
                    -0.349365234375,
                    0.243408203125,
                    0.1812744140625,
                    0.28076171875,
                    -0.33837890625,
                    -0.1441650390625,
                    -0.0301666259765625,
                    0.00946044921875,
                    -0.290283203125,
                    -0.105712890625,
                    -0.1041259765625,
                    -0.021820068359375,
                    -0.08697509765625,
                    -0.13232421875,
                    -0.1866455078125,
                    -0.12481689453125,
                    -0.23583984375,
                    0.1102294921875,
                    -0.1353759765625,
                    0.127197265625,
                    0.12066650390625,
                    0.132568359375,
                    -0.0777587890625,
                    -0.1407470703125,
                    -0.2347412109375,
                    0.09320068359375,
                    0.04351806640625,
                    0.099609375,
                    -0.058807373046875,
                    -0.10736083984375,
                    -0.0902099609375,
                    0.0595703125
                ],
                "intercept": -1.05859375,
                "mean": -1139.1035836784765
            },
            "m_canvas_emojis_fisher_5": {
                "x": [
                    53,
                    64,
                    51,
                    84,
                    12,
                    61,
                    28,
                    52,
                    76,
                    75,
                    26,
                    45,
                    16,
                    61,
                    6,
                    95,
                    19,
                    13,
                    82,
                    83,
                    47,
                    3,
                    13,
                    72,
                    11,
                    99,
                    97,
                    31,
                    0,
                    53,
                    83,
                    30,
                    78,
                    69,
                    57,
                    78,
                    47,
                    83,
                    52,
                    97,
                    32,
                    24,
                    43,
                    70,
                    53,
                    86,
                    24,
                    90,
                    10,
                    50,
                    94,
                    23,
                    49,
                    99,
                    19,
                    46,
                    49,
                    42,
                    48,
                    51,
                    93,
                    58,
                    50,
                    52,
                    13,
                    22,
                    91,
                    11,
                    17,
                    77,
                    36,
                    71,
                    41,
                    5,
                    96,
                    84,
                    67,
                    89,
                    26,
                    73,
                    9,
                    35,
                    62,
                    87,
                    37,
                    81,
                    91,
                    5,
                    74,
                    73,
                    59,
                    84,
                    19,
                    26,
                    79,
                    9,
                    53,
                    83,
                    93,
                    80,
                    14,
                    1,
                    46,
                    54,
                    87,
                    22,
                    86,
                    91,
                    74,
                    60,
                    28,
                    42,
                    50,
                    28,
                    68,
                    97,
                    42,
                    89,
                    93,
                    28,
                    23,
                    45,
                    81,
                    17,
                    50,
                    75,
                    87,
                    15,
                    41,
                    56,
                    28,
                    1,
                    27,
                    89,
                    25,
                    39,
                    23,
                    6,
                    93,
                    80,
                    95,
                    93,
                    4,
                    83,
                    70,
                    35,
                    22,
                    12,
                    25,
                    84,
                    18,
                    81,
                    21
                ],
                "y": [
                    57,
                    39,
                    55,
                    73,
                    70,
                    45,
                    90,
                    45,
                    26,
                    33,
                    82,
                    57,
                    91,
                    40,
                    72,
                    20,
                    86,
                    65,
                    33,
                    22,
                    55,
                    68,
                    92,
                    66,
                    87,
                    14,
                    6,
                    77,
                    73,
                    59,
                    27,
                    77,
                    68,
                    66,
                    38,
                    31,
                    65,
                    15,
                    49,
                    60,
                    64,
                    71,
                    65,
                    29,
                    53,
                    22,
                    77,
                    70,
                    92,
                    67,
                    22,
                    72,
                    66,
                    2,
                    90,
                    63,
                    54,
                    62,
                    58,
                    52,
                    10,
                    50,
                    46,
                    54,
                    86,
                    97,
                    16,
                    67,
                    65,
                    28,
                    72,
                    43,
                    63,
                    69,
                    7,
                    13,
                    73,
                    60,
                    88,
                    39,
                    94,
                    80,
                    57,
                    11,
                    82,
                    33,
                    21,
                    96,
                    28,
                    68,
                    69,
                    69,
                    87,
                    81,
                    67,
                    66,
                    47,
                    24,
                    67,
                    37,
                    66,
                    99,
                    64,
                    53,
                    32,
                    95,
                    20,
                    27,
                    71,
                    67,
                    66,
                    68,
                    47,
                    72,
                    37,
                    2,
                    60,
                    17,
                    13,
                    76,
                    86,
                    61,
                    26,
                    90,
                    58,
                    30,
                    26,
                    86,
                    72,
                    66,
                    91,
                    72,
                    79,
                    12,
                    70,
                    64,
                    86,
                    61,
                    65,
                    37,
                    8,
                    5,
                    70,
                    18,
                    66,
                    82,
                    87,
                    92,
                    94,
                    31,
                    69,
                    23,
                    86
                ],
                "channel": [
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    1,
                    2,
                    2,
                    0,
                    1,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    1,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    1,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    2,
                    1,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    2,
                    0,
                    0,
                    0
                ],
                "coefs": [
                    0.298583984375,
                    -0.248779296875,
                    -0.1788330078125,
                    -0.9638671875,
                    -0.07769775390625,
                    0.85107421875,
                    0.0970458984375,
                    0.98291015625,
                    0.634765625,
                    0.37841796875,
                    -1.00390625,
                    0.4228515625,
                    0.6259765625,
                    0.08416748046875,
                    -1.0966796875,
                    0.51171875,
                    0.254638671875,
                    -0.350341796875,
                    -0.03875732421875,
                    0.1973876953125,
                    0.587890625,
                    -0.399658203125,
                    0.5703125,
                    0.366943359375,
                    0.54150390625,
                    -0.11370849609375,
                    0.055877685546875,
                    0.1328125,
                    0.70849609375,
                    0.451171875,
                    0.1533203125,
                    0.28271484375,
                    -0.55712890625,
                    -0.03717041015625,
                    -0.416015625,
                    0.21875,
                    0.2021484375,
                    0.04193115234375,
                    0.65576171875,
                    -0.394775390625,
                    0.11236572265625,
                    -0.314697265625,
                    -0.10797119140625,
                    0.5283203125,
                    0.46435546875,
                    0.517578125,
                    0.2744140625,
                    -0.15283203125,
                    0.302490234375,
                    0.09014892578125,
                    -0.252197265625,
                    0.315673828125,
                    0.1346435546875,
                    -0.294189453125,
                    0.296875,
                    0.357177734375,
                    0.40771484375,
                    -0.412109375,
                    0.41259765625,
                    -0.2249755859375,
                    -0.18212890625,
                    0.5712890625,
                    0.1051025390625,
                    0.372802734375,
                    0.13671875,
                    0.072265625,
                    0.344482421875,
                    -0.26806640625,
                    0.181396484375,
                    -0.090087890625,
                    0.45947265625,
                    -0.172607421875,
                    -0.2342529296875,
                    0.33544921875,
                    -0.365234375,
                    0.53515625,
                    -0.7587890625,
                    -0.90380859375,
                    0.73974609375,
                    -0.376220703125,
                    -0.09344482421875,
                    0.37890625,
                    0.08111572265625,
                    0.59130859375,
                    -0.03472900390625,
                    -0.46484375,
                    0.2137451171875,
                    -0.2357177734375,
                    0.46484375,
                    0.1541748046875,
                    -0.1536865234375,
                    -0.2802734375,
                    -0.316650390625,
                    -0.474609375,
                    -0.23291015625,
                    -0.56298828125,
                    0.75,
                    0.39111328125,
                    0.350830078125,
                    -0.0006628036499023438,
                    -0.4638671875,
                    0.72607421875,
                    0.018707275390625,
                    0.1611328125,
                    0.041015625,
                    0.27099609375,
                    0.1004638671875,
                    0.284423828125,
                    0.1802978515625,
                    -0.15234375,
                    0.1802978515625,
                    -0.289306640625,
                    0.59619140625,
                    0.285888671875,
                    0.232421875,
                    -0.13330078125,
                    0.33984375,
                    0.230712890625,
                    0.261474609375,
                    0.267822265625,
                    0.02581787109375,
                    -0.3037109375,
                    0.337158203125,
                    0.44287109375,
                    0.1529541015625,
                    0.58544921875,
                    0.25146484375,
                    0.326904296875,
                    0.3017578125,
                    -0.223876953125,
                    0.0904541015625,
                    0.312255859375,
                    0.08544921875,
                    0.10589599609375,
                    -0.119140625,
                    -0.298583984375,
                    0.023956298828125,
                    -0.355712890625,
                    -0.1505126953125,
                    0.12091064453125,
                    0.294921875,
                    -0.37744140625,
                    -0.2100830078125,
                    0.260498046875,
                    0.174072265625,
                    -0.5126953125,
                    -0.467041015625,
                    0.21435546875,
                    0.0830078125,
                    0.218994140625,
                    0.237548828125,
                    -0.09539794921875,
                    0.296875
                ],
                "intercept": 69.5,
                "mean": 822.2679150143865
            },
            "m_canvas_emojis_fisher_6": {
                "x": [
                    52,
                    70,
                    15,
                    54,
                    85,
                    67,
                    61,
                    76,
                    93,
                    9,
                    95,
                    46,
                    50,
                    27,
                    85,
                    47,
                    10,
                    24,
                    18,
                    84,
                    80,
                    55,
                    90,
                    61,
                    99,
                    84,
                    76,
                    20,
                    90,
                    51,
                    11,
                    25,
                    65,
                    87,
                    67,
                    84,
                    93,
                    81,
                    22,
                    10,
                    45,
                    54,
                    42,
                    43,
                    72,
                    52,
                    56,
                    91,
                    50,
                    23,
                    96,
                    80,
                    80,
                    83,
                    95,
                    72,
                    27,
                    24,
                    23,
                    91,
                    12,
                    83,
                    99,
                    77,
                    28,
                    58,
                    80,
                    67,
                    31,
                    45,
                    10,
                    20,
                    5,
                    68,
                    87,
                    78,
                    11,
                    8,
                    91,
                    12,
                    75,
                    28,
                    92,
                    33,
                    17,
                    38,
                    88,
                    4,
                    95,
                    69,
                    71,
                    93,
                    84,
                    40,
                    86,
                    97,
                    47,
                    25,
                    59,
                    29,
                    30,
                    64,
                    23,
                    24,
                    50,
                    42,
                    44,
                    19,
                    74,
                    73,
                    96,
                    17,
                    69,
                    84,
                    95,
                    60,
                    56,
                    91,
                    75,
                    44,
                    84,
                    67,
                    11,
                    23,
                    80,
                    58,
                    51,
                    25,
                    89,
                    54,
                    4,
                    98,
                    15,
                    80,
                    66,
                    74,
                    14,
                    50,
                    74,
                    72,
                    26,
                    53,
                    38,
                    87,
                    89,
                    47,
                    66,
                    44,
                    17,
                    71,
                    48,
                    48,
                    13,
                    58,
                    53,
                    37,
                    48,
                    58,
                    74,
                    63,
                    51,
                    94,
                    64,
                    75,
                    50,
                    94,
                    52,
                    63,
                    27,
                    23,
                    69,
                    50
                ],
                "y": [
                    57,
                    35,
                    70,
                    57,
                    31,
                    73,
                    48,
                    29,
                    23,
                    61,
                    18,
                    64,
                    47,
                    91,
                    30,
                    59,
                    94,
                    80,
                    89,
                    66,
                    28,
                    54,
                    73,
                    36,
                    14,
                    24,
                    37,
                    86,
                    15,
                    53,
                    92,
                    93,
                    38,
                    24,
                    36,
                    26,
                    67,
                    27,
                    85,
                    63,
                    65,
                    70,
                    67,
                    66,
                    38,
                    48,
                    50,
                    18,
                    60,
                    86,
                    61,
                    71,
                    37,
                    14,
                    15,
                    69,
                    72,
                    87,
                    78,
                    21,
                    93,
                    21,
                    8,
                    34,
                    80,
                    53,
                    20,
                    33,
                    61,
                    57,
                    96,
                    85,
                    60,
                    43,
                    11,
                    70,
                    94,
                    74,
                    27,
                    92,
                    26,
                    81,
                    15,
                    63,
                    85,
                    81,
                    31,
                    97,
                    24,
                    50,
                    70,
                    66,
                    60,
                    62,
                    14,
                    1,
                    72,
                    94,
                    46,
                    76,
                    75,
                    41,
                    86,
                    81,
                    58,
                    66,
                    61,
                    87,
                    28,
                    32,
                    9,
                    91,
                    33,
                    11,
                    74,
                    37,
                    50,
                    68,
                    36,
                    60,
                    19,
                    45,
                    90,
                    85,
                    27,
                    74,
                    60,
                    88,
                    13,
                    56,
                    66,
                    16,
                    87,
                    26,
                    46,
                    26,
                    91,
                    61,
                    41,
                    34,
                    89,
                    52,
                    81,
                    32,
                    30,
                    65,
                    38,
                    67,
                    68,
                    48,
                    65,
                    70,
                    86,
                    55,
                    55,
                    77,
                    51,
                    44,
                    37,
                    41,
                    63,
                    60,
                    46,
                    39,
                    59,
                    12,
                    69,
                    39,
                    79,
                    86,
                    36,
                    52
                ],
                "channel": [
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    0,
                    2,
                    2,
                    2,
                    0,
                    1,
                    2,
                    2,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    1,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    2,
                    1,
                    2,
                    0,
                    2,
                    1,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    2,
                    2,
                    0,
                    1,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0
                ],
                "coefs": [
                    0.0297088623046875,
                    0.8544921875,
                    -0.31982421875,
                    -0.2147216796875,
                    -0.9814453125,
                    -1.0322265625,
                    0.44921875,
                    -0.1541748046875,
                    0.5341796875,
                    -0.8681640625,
                    0.385009765625,
                    -0.110595703125,
                    0.478271484375,
                    -0.57373046875,
                    -0.243408203125,
                    0.37548828125,
                    0.1741943359375,
                    0.52978515625,
                    0.317626953125,
                    -0.1563720703125,
                    0.338623046875,
                    0.1708984375,
                    -0.7509765625,
                    1.4013671875,
                    -0.33203125,
                    -0.2352294921875,
                    0.407958984375,
                    -0.64013671875,
                    0.52392578125,
                    0.07269287109375,
                    -0.174072265625,
                    0.9658203125,
                    0.2060546875,
                    -0.01294708251953125,
                    0.216796875,
                    -0.52978515625,
                    0.11236572265625,
                    -0.5166015625,
                    -0.09881591796875,
                    0.73388671875,
                    0.26708984375,
                    -0.293701171875,
                    -0.1522216796875,
                    -0.053497314453125,
                    0.326904296875,
                    -0.167236328125,
                    0.1187744140625,
                    0.6953125,
                    0.1533203125,
                    0.00040984153747558594,
                    -0.85595703125,
                    -0.1678466796875,
                    -0.00589752197265625,
                    0.54345703125,
                    -0.47265625,
                    0.4404296875,
                    0.301025390625,
                    -0.1219482421875,
                    0.40869140625,
                    0.381103515625,
                    -0.464111328125,
                    0.2900390625,
                    -0.08648681640625,
                    0.4384765625,
                    -0.1099853515625,
                    0.329833984375,
                    -0.478271484375,
                    0.8623046875,
                    -0.361572265625,
                    0.307861328125,
                    -0.25439453125,
                    -0.5703125,
                    -0.1915283203125,
                    0.403076171875,
                    0.46875,
                    -0.28857421875,
                    0.278076171875,
                    -0.888671875,
                    -0.10137939453125,
                    -0.2205810546875,
                    -0.004161834716796875,
                    -0.333984375,
                    0.38134765625,
                    -0.134033203125,
                    0.19287109375,
                    -0.1890869140625,
                    -0.057708740234375,
                    0.796875,
                    0.0560302734375,
                    0.04876708984375,
                    0.340087890625,
                    0.342041015625,
                    -1.0791015625,
                    0.0955810546875,
                    -0.207275390625,
                    0.2110595703125,
                    0.364013671875,
                    0.108154296875,
                    0.35546875,
                    0.266845703125,
                    -0.6298828125,
                    0.267333984375,
                    -0.1253662109375,
                    0.28125,
                    -0.07525634765625,
                    -0.1680908203125,
                    -0.50732421875,
                    -0.186279296875,
                    -0.283203125,
                    0.1866455078125,
                    0.3193359375,
                    -0.07012939453125,
                    0.12042236328125,
                    -0.071044921875,
                    -0.397705078125,
                    0.1328125,
                    0.11712646484375,
                    -0.10498046875,
                    0.6162109375,
                    0.25390625,
                    0.1905517578125,
                    -0.169677734375,
                    -0.5322265625,
                    -0.57275390625,
                    -0.28369140625,
                    -1.3583984375,
                    0.338134765625,
                    -0.10943603515625,
                    0.39501953125,
                    -0.319091796875,
                    -0.294921875,
                    0.01393890380859375,
                    0.310302734375,
                    0.237548828125,
                    0.252197265625,
                    -0.53076171875,
                    -0.180908203125,
                    0.2110595703125,
                    0.238037109375,
                    0.1676025390625,
                    0.171875,
                    -0.3740234375,
                    -0.376220703125,
                    -0.05499267578125,
                    0.07318115234375,
                    -0.32177734375,
                    0.18896484375,
                    -0.044219970703125,
                    -0.1710205078125,
                    0.08526611328125,
                    0.13916015625,
                    0.276123046875,
                    -0.060638427734375,
                    0.6279296875,
                    0.3251953125,
                    -0.2034912109375,
                    0.364501953125,
                    0.22021484375,
                    0.482177734375,
                    0.264892578125,
                    0.2283935546875,
                    -0.50244140625,
                    0.26904296875,
                    0.220703125,
                    0.349609375,
                    -0.17919921875,
                    -0.1263427734375,
                    0.1163330078125,
                    -0.080078125,
                    -0.041839599609375,
                    0.1387939453125,
                    0.196533203125
                ],
                "intercept": -18.703125,
                "mean": 234.31928188267278
            }
        },
        "m_canvas_geometry": {
            "m_canvas_geometry_fisher_13": {
                "x": [
                    0,
                    104,
                    31,
                    18,
                    0,
                    104,
                    86,
                    93,
                    1,
                    115,
                    78,
                    106,
                    107,
                    26,
                    97,
                    110,
                    3,
                    120,
                    105,
                    78,
                    38,
                    49,
                    0,
                    14,
                    53,
                    102,
                    1,
                    68,
                    20,
                    5,
                    27,
                    107,
                    114,
                    102,
                    117,
                    38,
                    26,
                    0,
                    91,
                    2,
                    48,
                    97,
                    109,
                    26
                ],
                "y": [
                    32,
                    60,
                    113,
                    5,
                    70,
                    7,
                    114,
                    110,
                    75,
                    20,
                    117,
                    70,
                    10,
                    110,
                    3,
                    13,
                    22,
                    40,
                    71,
                    45,
                    116,
                    0,
                    46,
                    8,
                    119,
                    6,
                    27,
                    119,
                    4,
                    86,
                    1,
                    69,
                    61,
                    73,
                    25,
                    79,
                    110,
                    48,
                    78,
                    24,
                    0,
                    3,
                    67,
                    110
                ],
                "channel": [
                    0,
                    1,
                    2,
                    2,
                    2,
                    0,
                    0,
                    2,
                    2,
                    1,
                    2,
                    2,
                    0,
                    2,
                    0,
                    1,
                    2,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    0,
                    0,
                    1,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    2,
                    0,
                    2,
                    2,
                    1,
                    0
                ],
                "coefs": [
                    1.29296875,
                    -17.078125,
                    66.25,
                    0.828125,
                    -5.79296875,
                    0.21630859375,
                    80.0625,
                    18.421875,
                    79.5625,
                    0.86181640625,
                    -30.15625,
                    -1.9951171875,
                    30.34375,
                    -79.25,
                    -9.546875,
                    7.9609375,
                    0.1561279296875,
                    0.1993408203125,
                    0.32275390625,
                    23.765625,
                    8.828125,
                    -28.921875,
                    -21.71875,
                    -0.216552734375,
                    -27.953125,
                    11.421875,
                    -1.0791015625,
                    14.1953125,
                    -1.0029296875,
                    11.59375,
                    0.1505126953125,
                    7.6484375,
                    -7.375,
                    -7.64453125,
                    -16.46875,
                    31.109375,
                    8.2734375,
                    -14.8828125,
                    -27.96875,
                    6.26171875,
                    16.640625,
                    4.27734375,
                    -12.796875,
                    -5.29296875
                ],
                "intercept": -15.5859375,
                "mean": -15736.773126562157
            },
            "m_canvas_geometry_fisher_4": {
                "x": [
                    26,
                    113,
                    93,
                    10,
                    18,
                    115,
                    49,
                    0,
                    99,
                    95,
                    70,
                    22,
                    97,
                    9,
                    27,
                    8,
                    115,
                    107,
                    113,
                    2,
                    2,
                    120,
                    117,
                    116,
                    4,
                    0,
                    105,
                    3,
                    12,
                    17,
                    86,
                    112,
                    110,
                    72,
                    94,
                    117,
                    1,
                    4,
                    23,
                    1,
                    92,
                    27,
                    28,
                    20,
                    69,
                    75,
                    104,
                    9,
                    4,
                    32,
                    0,
                    105,
                    48,
                    18
                ],
                "y": [
                    9,
                    88,
                    110,
                    12,
                    5,
                    20,
                    119,
                    46,
                    4,
                    98,
                    0,
                    3,
                    107,
                    93,
                    1,
                    14,
                    83,
                    69,
                    62,
                    25,
                    24,
                    40,
                    55,
                    22,
                    83,
                    31,
                    8,
                    22,
                    10,
                    6,
                    114,
                    15,
                    13,
                    118,
                    109,
                    60,
                    27,
                    21,
                    108,
                    75,
                    1,
                    1,
                    103,
                    4,
                    119,
                    116,
                    72,
                    26,
                    20,
                    0,
                    33,
                    71,
                    0,
                    5
                ],
                "channel": [
                    2,
                    2,
                    2,
                    2,
                    0,
                    1,
                    2,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    0,
                    2,
                    2,
                    1,
                    1,
                    2,
                    0,
                    1,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    2,
                    0,
                    1,
                    1,
                    0,
                    2,
                    2,
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    1,
                    0,
                    2,
                    1,
                    1,
                    1,
                    2,
                    1
                ],
                "coefs": [
                    4.08984375,
                    0.8310546875,
                    -1.3466796875,
                    -1.0205078125,
                    -1.65234375,
                    0.01250457763671875,
                    -0.492431640625,
                    -3.470703125,
                    0.222412109375,
                    3.66015625,
                    0.325439453125,
                    -0.093994140625,
                    -1.0771484375,
                    1.0908203125,
                    1.171875,
                    0.050048828125,
                    -0.4287109375,
                    -1.1669921875,
                    -0.7802734375,
                    -1.427734375,
                    0.12017822265625,
                    -0.0017118453979492188,
                    -1.0283203125,
                    -0.16455078125,
                    0.33056640625,
                    -0.027374267578125,
                    -0.1492919921875,
                    -0.5009765625,
                    1.146484375,
                    -0.7109375,
                    0.62451171875,
                    -0.09375,
                    -0.2139892578125,
                    0.425048828125,
                    0.830078125,
                    -0.0849609375,
                    -0.0966796875,
                    0.3525390625,
                    0.0017709732055664062,
                    0.2099609375,
                    0.223876953125,
                    0.05767822265625,
                    0.15185546875,
                    0.0195159912109375,
                    0.3564453125,
                    1.5322265625,
                    0.09747314453125,
                    0.71044921875,
                    -0.1317138671875,
                    0.224853515625,
                    0.342041015625,
                    -0.327392578125,
                    0.167724609375,
                    -0.0372314453125
                ],
                "intercept": 1.4638671875,
                "mean": 144.5413400045915
            }
        }
    },
    "modelId": "TINTO_THN_20230713_01_RELEVANCE_THR_099_T20230420_20230503"
};

export { model };
